import { AfterViewInit, Component, ElementRef, ErrorHandler, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy, signal, untracked } from '@angular/core'
import { ValidationErrors, ValidatorFn } from '@angular/forms'
import { FieldTree, form } from '@angular/forms/signals'
import { Router } from '@angular/router'

import { Platform } from '@angular/cdk/platform'
import { DateAdapter } from '@angular/material/core'
import { MatDatepicker } from '@angular/material/datepicker'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'

import { AsiakasService } from '../_angular/service/asiakas/asiakas.service'
import { KirjautunutKayttajaService } from '../_angular/service/kirjautunut-kayttaja.service'

import { KirjanpitajanRooli } from '@lemon/core-firebase/lemonator/model/kirjanpitaja'
import { MUU_LASKUTUS, TilastoKategoria, tuotenimikkeet } from '@lemon/core-firebase/model/tuotenimikkeet'
import { AnnaAsiakkaidenNimitiedotPyynto, AnnaAsiakkaidenNimitiedotVastaus, AsiakasTagi, AsiakkaanNimitiedot } from 'app/_jaettu-lemonator/model/asiakas'
import {
  AnnaAsiakkaidenTilastotiedotKirjanpitajittain,
  AnnaAsiakkaidenTilastotiedotKirjanpitajittainPyynto,
  AnnaAsiakkaidenTilastotiedotKirjanpitajittainVastaus,
  AnnaAsiakkaidenTilastotiedotPyynto,
  AnnaAsiakkaidenTilastotiedotVastaus,
  AsiakkaanTilastotiedot,
  HinnanMuutos,
  JatkuvaKuukaudenLaskutusJakaumallaPyynto,
  JatkuvanLaskutuksenKehitysKentta,
  JatkuvanLaskutuksenKehitysTiedot,
  JatkuvanLaskutuksenKehitysVastaus,
  JatkuvanLaskutuksenLahdeTieto,
  LaskutuksenMuutos,
  MyyntiyhteenvetoJakaumallaPyynto,
  MyyntiYhteenvetoLahdeTietoNimitiedoilla,
  MyyntiYhteenvetoVastaus,
} from 'app/_jaettu-lemonator/model/tilastot'

import { CurrencyService } from '@lemon/core/service/currency.service'

import { BehaviorSubject, combineLatest, EMPTY, firstValueFrom, Observable, of as observableOf, Subject } from 'rxjs'
import { distinctUntilChanged, map, switchMap, takeUntil, tap } from 'rxjs/operators'

import { KirjanpitajaService } from '../_angular/service/kirjanpitaja/kirjanpitaja.service'

import { DateService } from '@lemon/core/service/date.service'
import { LemonKuukausiDateAdapter } from 'app/_jaettu-angular/_material/LemonKuukausiDateAdapter'

import { Yritysmuoto } from '@lemon/core-firebase/model/kayttaja'
import { KirjanpidonProjekti } from '@lemon/core-firebase/model/kirjanpito-projektit'
import { KopioijaPalvelu } from '@lemon/core-firebase/service/kopioija.service'
import { LaskuSharedService } from '@lemon/core-firebase/service/lasku/lasku-shared.service'
import { SpreadsheetBuilder } from '@lemon/core-firebase/utils/csv'
import { KuukausiAikavali, LocalMonth } from '@lemon/core/model/common'
import { AsiakasKopioija } from 'app/_angular/service/asiakas/asiakas.kopioija'
import { FirebaseLemonaid, FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { VersionTarkistusPalvelu } from 'app/_angular/service/version-tarkistus.palvelu'
import { arvonMuutokset, asetaArvo } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { validoiReaktiivisesti } from 'app/_jaettu-angular/_lomakkeet/reaktiivinen-validaattori'
import { lemonShare } from 'app/_jaettu-angular/_rxjs/lemon-share.operator'
import { FileSaverService } from 'app/_jaettu-angular/service/file-saver'
import { LemonTranslationService } from 'app/_jaettu-angular/service/lemon-translation.service'
import { TimestampService } from 'app/_jaettu-angular/service/timestamp-service'
import { AsiakkaanSopimuskaudenTila } from 'app/_jaettu-lemonator/model/asiakas'
import { KirjanpitajanNimitiedot, KirjanpitajanTiimi, KirjanpitajanTiimikokonaisuus } from 'app/_jaettu-lemonator/model/kirjanpitaja'
import { AsiakasJaettuService } from 'app/_jaettu-lemonator/service/asiakas-jaettu.service'
import { YllapitoUriService } from 'app/_jaettu-lemonator/service/yllapito-uri.service'
import { ArcElement, BarController, BarElement, CategoryScale, Chart, Legend, LinearScale, LineController, LineElement, PieController, PointElement, Tooltip } from 'chart.js'
import { KirjanpitajanTiimiService } from '../_jaettu-lemonator/service/kirjanpitajan-tiimi.service'

Chart.register(PieController, LineController, BarController, CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend)

interface AsiakasInfo {
  asiakkaita: number
  asiakkaitaJoillaHinta: number
  yhtiomuotojakauma: { nimi: string; maara: number; keskimaarainenHinta: number }[]
  keskimaarainenhinta: number
}

interface PeriodinLoppuInfo {
  asiakkaita: number
  liikevaihto: number
  keskihinta: number
  yhtiomuotojakauma: { nimi: string; maara: number }[]
  kuukausi: number
  vuosi: number
  tauolla: number
  poytalaatikossa: number
}

interface KuukausittainenLaskutusData {
  kuukausi: LocalMonth
  laskuista: {
    kerta: number
    jatkuva: number
    hyvityksetKerta: number
    hyvityksetJatkuva: number
  }
  hinnastosta: {
    lisays: number
    poistuma: number
    laskutus: number
  }
}

interface KuukausittaisenTablenRivi {
  bold: boolean
  cols: string[]
}

interface MyyntiyhteenvetoRivi {
  bold: boolean
  cols: MyyntiyhteenvetoSolu[]
  nimi: string
  kategoriaAvain?: string
  kuuluuKategoriaan?: string
  onKlikattavaKategoria?: boolean
  onAlakategoria?: boolean
  onYhteensaRivi?: boolean
}

interface MyyntiyhteenvetoSolu {
  arvo: string
  vuosi?: number
  kuukausi?: number
  tuote?: string | 'kaikki'
  onHyvitys?: boolean
  summa?: number
  onPalvelumyynti?: boolean
}

interface JatkuvaLaskutusKuukausittaisenTablenRivi {
  bold: boolean
  cols: KuukausittaisenSolunData[]
  nimi?: string
  offset?: boolean
  divider?: boolean
  grey?: boolean
}

interface KuukausittaisenSolunData {
  arvo: string
  vuosi: number
  kuukausi: number
  kentta?: JatkuvanLaskutuksenKehitysKentta
  summa?: number
  kpl?: number
}

interface AsiakkaanHinnanMuutokset {
  asiakas: AsiakkaanTilastotiedot
  kirjanpitaja: KirjanpitajanNimitiedot
  hinnat: HinnanMuutos[]
}

interface KirjanpitajatLomake {
  vuosikkalku: Date | null
}

interface TilastotLomake {
  vuosikkalku: Date | null
  vuosikkloppu: Date | null
  kirjanpitaja: string | null
  tiimi: KirjanpitajanTiimi['avain'] | null
  tiimiKokonaisuus: KirjanpitajanTiimikokonaisuus['avain'] | null
  tagi: string | null
}

@Component({
  templateUrl: './tilastot.component.html',
  styleUrls: ['./tilastot.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: LemonKuukausiDateAdapter, deps: [ErrorHandler, DateService, Platform, LemonTranslationService] },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TilastotComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) _sort: MatSort
  @ViewChild('kuukausittainCanvas', { static: true }) kuukausittainCanvasRef: ElementRef
  // @ViewChild('kuukausittainenMuutosCanvas', { static: true }) kuukausittainenMuutosCanvasRef: ElementRef
  @ViewChild('kuukausittainKirjanpitajittainCanvas') kuukausittainKirjanpitajittainCanvasRef: ElementRef
  @ViewChild('yhtiojakaumaCanvas', { static: false }) yhtiojakaumaCanvas: ElementRef

  readonly kuukausittainCanvasDataOnLataamatta = signal(true)
  // kuukausittainenMuutosCanvasOnLataamatta = true
  readonly kuukausittainKirjanpitajittainCanvasOnLataamatta = signal(true)
  readonly kirjanpitajittainTableLataa = signal(true)
  readonly jatkuvanLaskutuksenKehitysTableLataa = signal(true)
  readonly myyntiyhteenvetoTableLataa = signal(true)

  readonly valittuSolu = signal<KuukausittaisenSolunData | null>(null)
  readonly valitunSolunLahteet = signal<JatkuvanLaskutuksenLahdeTieto[] | null>(null)
  readonly valitunSolunLahteetYhteissumma = signal(0)
  readonly lataaLahteet = signal(true)

  readonly valittuMyyntiyhteenvetoSolu = signal<MyyntiyhteenvetoSolu | null>(null)
  readonly valittuMyyntiyhteenvetoTuoteNimi = signal<string | null>(null)
  readonly valitunMyyntiyhteenvetoSolunLahteet = signal<MyyntiYhteenvetoLahdeTietoNimitiedoilla[] | null>(null)
  readonly lataaMyyntiyhteenvetoLahteet = signal(true)
  readonly myyntiyhteenvetoLahteetEiTasmaa = signal(false)
  readonly myyntiyhteenvetoLahteidenSumma = signal(0)

  readonly jatkuvaLaskutusValidointi = signal({
    eiTasmaa: false,
    summa: 0,
    kpl: 0,
  })
  asiakkaatMap: { [avain: string]: AsiakkaanNimitiedot } = {}

  readonly kirjanpitajittainTableYhteensa = signal({
    asiakkaita: 0,
    jatkuvakk1: 0,
    jatkuvakk2: 0,
    lisayksia: 0,
    poistuma: 0,
    keskim: 0,
    oy: 0,
    tmi: 0,
    muut: 0,
  })

  kirjanpitajatDataSource: MatTableDataSource<AnnaAsiakkaidenTilastotiedotKirjanpitajittain> = new MatTableDataSource([])

  private varit: string[] = [
    'rgba(184, 231, 166, 1)',
    'rgba(242, 167, 180, 1)',
    'rgba(153, 196, 231, 1)',
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(231, 233, 237, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(151, 187, 205, 1)',
    'rgba(220, 220, 220, 1)',
    'rgba(247, 70, 74, 1)',
    'rgba(70, 191, 189, 1)',
    'rgba(253, 180, 92, 1)',
    'rgba(148, 159, 177, 1)',
    'rgba(77, 83, 96, 1)',
  ]

  private yhtiomuodotVarit: string[] = [
    '#5DD5F5',
    '#3ECBF4',
    '#78DFF7',
    '#A8E8F7',
    '#4DCBEB',
    '#C2F0FA',
    '#6ED9F4',
    '#8FE3F6',
    '#167DAD',
    '#1E88C7',
    '#0D7BA8',
    '#0A4560',
    '#095070',
    '#0B5F82',
    '#083A4F',
  ]

  lomake: FieldTree<TilastotLomake>
  kirjanpitajatLomake: FieldTree<KirjanpitajatLomake>
  private _valittuAikavaliSubject: BehaviorSubject<KuukausiAikavali> = new BehaviorSubject(null)
  private _valittuAikavaliObservable: Observable<KuukausiAikavali> = this._valittuAikavaliSubject.asObservable()
  // .pipe(
  //   distinctUntilChanged((prev, next) => {
  //     if (
  //       prev.start.year !== next.start.year ||
  //       prev.end.year !== next.end.year ||
  //       prev.start.month !== next.start.month ||
  //       prev.end.month !== next.end.month
  //     ) {
  //       return false
  //     }
  //     return true
  //   })
  // )
  private _valittuKirjanpitajienAikavaliSubject: BehaviorSubject<KuukausiAikavali> = new BehaviorSubject(null)
  valittuKirjanpitajienKk1Observable = this._valittuKirjanpitajienAikavaliSubject.pipe(
    map(aikavali => {
      if (aikavali?.start) {
        return '1.' + aikavali.start.month
      }
    }),
  )
  valittuKirjanpitajienKk2Observable = this._valittuKirjanpitajienAikavaliSubject.pipe(
    map(aikavali => {
      if (aikavali?.start) {
        const next = this._dateService.lisaaKuukausiaLocalMonth(aikavali.start, 1)
        return '1.' + next.month
      }
    }),
  )
  purettuAikavaliPlusKuukausiMolempiinPaihinObservable: Observable<LocalMonth[]>
  // kuukausittainenJakaumaObservable: Observable<KuukaudenLaskutusJakaumallaTiedot[]>
  // kirjanpitajittainJakaumaObservable: Observable<KuukaudenLaskutusKirjanpitajittainJakaumallaTiedot[]>
  // kirjanpitajatTablenTiedotObservable: Observable<KirjanpitajatTablenTiedot[]>
  kirjanpitajienNimitiedotObservable: Observable<KirjanpitajanNimitiedot[]>
  naytaPoistuneetKirjanpitajatSubject: BehaviorSubject<boolean> = new BehaviorSubject(false)
  tiimitObservable: Observable<KirjanpitajanTiimi[]>
  tiimikokonaisuudetObservable: Observable<KirjanpitajanTiimikokonaisuus[]>
  kaikkiTagitObservable: Observable<AsiakasTagi[]>
  kuukausittaisenDatanRivitObservable: Observable<KuukausittaisenTablenRivi[]>
  jatkuvanLaskutuksenKehitysObservable: Observable<JatkuvaLaskutusKuukausittaisenTablenRivi[]>
  jatkuvanLaskutuksenPeriodinLoppuKplObservable: Observable<number>
  periodinLoppuInfoObservable: Observable<PeriodinLoppuInfo>
  myyntiYhteenvetoObservable: Observable<MyyntiyhteenvetoRivi[]>
  kaikkiKirjanpitoprojektitObservable: Observable<KirjanpidonProjekti[]>

  asiakkaidenKuukausihintojenMuutoksetObservable: Observable<AsiakkaanHinnanMuutokset[]>
  asiakkaidenKuukausihintojenSummatObservable: Observable<{ localMonth: LocalMonth; poistuma: number; lisays: number; summa: number }[]>

  asiakasInfoObservable: Observable<AsiakasInfo>
  asiakkaatObservable: Observable<AsiakkaanTilastotiedot[]>

  private ngUnsubscribe: Subject<void> = new Subject<void>()

  // private kolmenViimeisenKuunLaskutObservable: Observable<Lasku[]>
  // duplikaattiLaskutObservable: Observable<DuplikaattiLasku[]>
  // duplikaatitLataavatObservable: Observable<boolean>

  naytaSuperObservable: Observable<boolean>
  naytaSpeccerObservable: Observable<boolean>
  naytaItJaKayttotukiObservable: Observable<boolean>
  naytaTarkkaJakauma = form(signal(false))
  naytaTarkkaJakaumaKirjanpitajat = form(signal(false))
  etsiName = 'mhgyuketer' + Math.random()

  avautunutMyyntiyhteenvetoKategoriat = new Set<string>()

  private kuukausittainChart: Chart = null
  // private kuukausittainenMuutosChart: Chart = null
  private yhtiojakaumaChart: Chart<'pie', number[], string> = null
  private kuukausittainKirjanpitajittainChart: Chart = null

  private _rajauksetSubject: BehaviorSubject<{ kirjanpitaja: string; tiimi: KirjanpitajanTiimi['avain']; tiimiKokonaisuus: KirjanpitajanTiimikokonaisuus['avain'] }> = new BehaviorSubject({
    kirjanpitaja: null,
    tiimi: null,
    tiimiKokonaisuus: null,
  })

  private _valittuTagiSubject: BehaviorSubject<string> = new BehaviorSubject(null)

  constructor(
    private _errorHandler: ErrorHandler,
    private _router: Router,
    private _asiakasService: AsiakasService,
    private _asiakasJaettuService: AsiakasJaettuService,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _kirjanpitajaService: KirjanpitajaService,
    private _currencyService: CurrencyService,
    private _dateService: DateService,
    private _firebase: FirebaseLemonator,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _laskuSharedService: LaskuSharedService,
    private _versionTarkistusPalvelu: VersionTarkistusPalvelu,
    private _asiakasKopioija: AsiakasKopioija,
    private _timestampService: TimestampService,
    private _kopioijaPalvelu: KopioijaPalvelu,
    private _kirjanpitajanTiimiService: KirjanpitajanTiimiService,
    private _fileSaverService: FileSaverService,
    private _yllapitoUriService: YllapitoUriService,
  ) {
    this.tiimitObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(k => {
        return this._kirjanpitajanTiimiService.annaKaikkiTiimit()
      }),
    )

    this.kaikkiTagitObservable = this._firebase
      .firestoreCollection<AsiakasTagi>(this._yllapitoUriService.annaAsiakasTagitCollectionUri())
      .listen()
      .pipe(
        map(tagit => (tagit || []).sort((a, b) => a.nimi.localeCompare(b.nimi))),
        lemonShare(),
      )

    this.tiimikokonaisuudetObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(k => {
        return this._kirjanpitajanTiimiService.annaKaikkiTiimikokonaisuudet()
      }),
    )

    // Laske viimeisen 3kk aktiiviset kirjanpitäjät kerran ja cacheta tulos
    const viimeisen3kkAktiivisetKirjanpitajatObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      switchMap(async () => {
        const currentNumberDate = this._dateService.currentNumberDate()
        const kolmeKkSitten = this._dateService.lisaaKuukausiaNumero(currentNumberDate, -3)
        const tiimitViimeisen3kk = await this._kirjanpitajanTiimiService.annaTiimitPaivamaaraValille(kolmeKkSitten, currentNumberDate)
        const viimeisen3kkAktiivisetKirjanpitajat: Set<string> = new Set()
        for (const tiimi of tiimitViimeisen3kk) {
          for (const kp of tiimi.esihenkilot) {
            viimeisen3kkAktiivisetKirjanpitajat.add(kp.kirjanpitajaAvain)
          }
          for (const kp of tiimi.jasenet) {
            viimeisen3kkAktiivisetKirjanpitajat.add(kp.kirjanpitajaAvain)
          }
        }
        return viimeisen3kkAktiivisetKirjanpitajat
      }),
    )

    this.kirjanpitajienNimitiedotObservable = combineLatest([
      this._kirjanpitajaService.kirjanpitajienNimitiedotObservable,
      this._rajauksetSubject,
      this.naytaPoistuneetKirjanpitajatSubject,
      viimeisen3kkAktiivisetKirjanpitajatObservable,
    ]).pipe(
      switchMap(async ([kirjanpitajat, rajaukset, naytaPoistuneet, viimeisen3kkAktiivisetKirjanpitajat]) => {
        if (kirjanpitajat?.length) {
          const sorted = kirjanpitajat.sort((a, b) => {
            if (a.etunimi !== b.etunimi) {
              return a.etunimi.localeCompare(b.etunimi)
            }
            return a.sukunimi.localeCompare(b.sukunimi)
          })

          // Suodata pois kirjanpitäjät jotka eivät ole olleet tiimissä viimeisen 3kk aikana (ellei naytaPoistuneet ole päällä)
          const filteredBy3kk = naytaPoistuneet ? sorted : sorted.filter(kirjanpitaja => viimeisen3kkAktiivisetKirjanpitajat.has(kirjanpitaja.avain))

          if (rajaukset.tiimi) {
            const tiimi = await this._kirjanpitajanTiimiService.annaTiimi(rajaukset.tiimi)
            const filterSet = naytaPoistuneet
              ? this._kirjanpitajanTiimiService.annaTiiminKirjanpitajatIlmanRajauksia(tiimi)
              : this._kirjanpitajanTiimiService.annaTiiminKirjanpitajatPaivalleSet(tiimi, this._dateService.currentNumberDate())
            return filteredBy3kk.filter(kirjanpitaja => filterSet.has(kirjanpitaja.avain))
          }

          return filteredBy3kk
        }
        return []
      }),
    )

    const nyt = new Date()
    const ensiKuussa = this._dateService.lisaaKuukausia(nyt, 1)
    const puolivuottaSitten = this._dateService.lisaaKuukausia(nyt, -2)

    this._valittuAikavaliSubject.next({
      start: {
        month: puolivuottaSitten.getMonth() + 1,
        year: puolivuottaSitten.getFullYear(),
      },
      end: {
        month: ensiKuussa.getMonth() + 1,
        year: ensiKuussa.getFullYear(),
      },
    })

    this.purettuAikavaliPlusKuukausiMolempiinPaihinObservable = this._valittuAikavaliObservable.pipe(
      map(aikavali => {
        const alku = this._dateService.lisaaKuukausiaPaikallinen({ year: aikavali.start.year, month: aikavali.start.month, day: 12 }, -1)
        const loppu = this._dateService.lisaaKuukausiaPaikallinen({ year: aikavali.end.year, month: aikavali.end.month, day: 12 }, 1)
        return this.puraJaSuodataAikavali({ start: alku, end: loppu }, null)
      }),
    )

    this.lomake = form(signal<TilastotLomake>({ vuosikkalku: puolivuottaSitten, vuosikkloppu: ensiKuussa, kirjanpitaja: null, tiimi: null, tiimiKokonaisuus: null, tagi: null }), polku => {
      validoiReaktiivisesti(polku.vuosikkalku, this._endBeforeStartValidator)
      validoiReaktiivisesti(polku.vuosikkloppu, this._endBeforeStartValidator)
    })

    arvonMuutokset(this.lomake.kirjanpitaja)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: string) => {
        if (this._rajauksetSubject.value.kirjanpitaja !== value) {
          this.kuukausittainCanvasDataOnLataamatta.set(true)
          // this.kuukausittainenMuutosCanvasOnLataamatta = true
          this.kuukausittainKirjanpitajittainCanvasOnLataamatta.set(true)
          this.kirjanpitajittainTableLataa.set(true)
          this.jatkuvanLaskutuksenKehitysTableLataa.set(true)
          this.myyntiyhteenvetoTableLataa.set(true)
          this._rajauksetSubject.value.kirjanpitaja = value
          this._rajauksetSubject.next(this._rajauksetSubject.value)
        }
      })

    arvonMuutokset(this.lomake.tiimi)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        if (this._rajauksetSubject.value.tiimi !== value) {
          this.kuukausittainCanvasDataOnLataamatta.set(true)
          // this.kuukausittainenMuutosCanvasOnLataamatta = true
          this.kuukausittainKirjanpitajittainCanvasOnLataamatta.set(true)
          this.kirjanpitajittainTableLataa.set(true)
          this.jatkuvanLaskutuksenKehitysTableLataa.set(true)
          this.myyntiyhteenvetoTableLataa.set(true)
          this._rajauksetSubject.value.tiimi = value
          this._rajauksetSubject.value.kirjanpitaja = null
          this._rajauksetSubject.next(this._rajauksetSubject.value)
        }
      })

    arvonMuutokset(this.lomake.tiimiKokonaisuus)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        if (this._rajauksetSubject.value.tiimiKokonaisuus !== value) {
          this.kuukausittainCanvasDataOnLataamatta.set(true)
          // this.kuukausittainenMuutosCanvasOnLataamatta = true
          this.kuukausittainKirjanpitajittainCanvasOnLataamatta.set(true)
          this.kirjanpitajittainTableLataa.set(true)
          this.jatkuvanLaskutuksenKehitysTableLataa.set(true)
          this.myyntiyhteenvetoTableLataa.set(true)
          this._rajauksetSubject.value.tiimiKokonaisuus = value
          this._rajauksetSubject.value.tiimi = null
          this._rajauksetSubject.value.kirjanpitaja = null
          this._rajauksetSubject.next(this._rajauksetSubject.value)
        }
      })

    arvonMuutokset(this.lomake.tagi)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: string) => {
        if (this._valittuTagiSubject.value !== value) {
          this.jatkuvanLaskutuksenKehitysTableLataa.set(true)
          this.myyntiyhteenvetoTableLataa.set(true)
          this.kirjanpitajittainTableLataa.set(true)
          this._valittuTagiSubject.next(value)
        }
      })

    this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: async kirjanpitajanTiedot => {
        if (kirjanpitajanTiedot && !this.lomake.tiimi().value()) {
          const tiimit = await this._kirjanpitajanTiimiService.annaTiimitJotaKirjanpitajaVetaa(kirjanpitajanTiedot.uid, this._dateService.currentNumberDate())
          if (tiimit?.length > 0) {
            asetaArvo(this.lomake.tiimi, tiimit[0].avain)
          }
        }
      },
    })

    this.asiakkaatObservable = combineLatest([this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable, this._rajauksetSubject, this._valittuAikavaliObservable, this._valittuTagiSubject]).pipe(
      switchMap(([kirjautunutKirjanpitaja, rajaukset, aikavali, tagiAvain]) => {
        if (!kirjautunutKirjanpitaja) {
          return observableOf([])
        }

        const pyynto: AnnaAsiakkaidenTilastotiedotPyynto = {
          rajoitettuKirjanpitajaanAvain: null,
          rajoitettuTiimiinAvain: rajaukset.tiimi ?? null,
          rajoitettuTagiinAvain: tagiAvain ?? null,
        }
        if (kirjautunutKirjanpitaja.rooli === KirjanpitajanRooli.SUPER) {
          if (rajaukset.kirjanpitaja) {
            pyynto.rajoitettuKirjanpitajaanAvain = rajaukset.kirjanpitaja
          }
          pyynto.aikavali = aikavali
        } else {
          pyynto.rajoitettuKirjanpitajaanAvain = kirjautunutKirjanpitaja.uid
        }

        return this._firebase.functionsCall<AnnaAsiakkaidenTilastotiedotPyynto, AnnaAsiakkaidenTilastotiedotVastaus>('tilastotAsiakkaidenTilastotiedot', pyynto).then(nimitiedotVastaus => {
          return nimitiedotVastaus?.tiedot ?? []
        })
      }),
      lemonShare(),
    )

    arvonMuutokset(this.lomake.vuosikkalku)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: Date) => {
        console.log('vuosikkalku', this.lomake.vuosikkalku().valid(), this.lomake.vuosikkalku().errors())
        if (!value || !this.lomake.vuosikkalku().valid()) {
          return
        }
        // console.log('asetettu vuosikkalku', value)
        const current = this._valittuAikavaliSubject.value
        const newStart: LocalMonth = { month: value.getMonth() + 1, year: value.getFullYear() }
        if (newStart.year !== current.start.year || newStart.month !== current.start.month) {
          // console.log('SET START', newStart, current.start)
          current.start = newStart
          this.kuukausittainCanvasDataOnLataamatta.set(true)
          // this.kuukausittainenMuutosCanvasOnLataamatta = true
          this.kuukausittainKirjanpitajittainCanvasOnLataamatta.set(true)
          this.jatkuvanLaskutuksenKehitysTableLataa.set(true)
          this.myyntiyhteenvetoTableLataa.set(true)
          this._valittuAikavaliSubject.next(current)
        }
      })

    arvonMuutokset(this.lomake.vuosikkloppu)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: Date) => {
        if (!value || !this.lomake.vuosikkloppu().valid()) {
          return
        }
        // console.log('asetettu vuosikkloppu', value)
        const current = this._valittuAikavaliSubject.value
        const newEnd: LocalMonth = { month: value.getMonth() + 1, year: value.getFullYear() }
        if (newEnd.year !== current.end.year || newEnd.month !== current.end.month) {
          // console.log('SET END', newEnd, current.end)
          current.end = newEnd
          this.kuukausittainCanvasDataOnLataamatta.set(true)
          // this.kuukausittainenMuutosCanvasOnLataamatta = true
          this.kuukausittainKirjanpitajittainCanvasOnLataamatta.set(true)
          this.jatkuvanLaskutuksenKehitysTableLataa.set(true)
          this.myyntiyhteenvetoTableLataa.set(true)
          this._valittuAikavaliSubject.next(current)
        }
      })

    this._valittuKirjanpitajienAikavaliSubject.next({
      start: {
        month: nyt.getMonth() + 1,
        year: nyt.getFullYear(),
      },
      end: {
        month: ensiKuussa.getMonth() + 1,
        year: ensiKuussa.getFullYear(),
      },
    })

    this.kirjanpitajatLomake = form(signal<KirjanpitajatLomake>({ vuosikkalku: nyt }))

    arvonMuutokset(this.kirjanpitajatLomake.vuosikkalku)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        if (value) {
          // console.log('asetettu vuosikkalku', value)
          this.kirjanpitajittainTableLataa.set(true)
          const current = this._valittuKirjanpitajienAikavaliSubject.value
          current.start = { month: value.getMonth() + 1, year: value.getFullYear() }
          this._valittuKirjanpitajienAikavaliSubject.next(current)
        }
      })
  }

  private annaYhtiomuodonNimi(yritysmuoto: Yritysmuoto) {
    switch (yritysmuoto) {
      case Yritysmuoto.AVOINYHTIO:
        return 'Avoin yhtiö'
      case Yritysmuoto.KOMMANDIITTIYHTIO:
        return 'Kommandiittiyhtiö'
      case Yritysmuoto.OSAKEYHTIO:
        return 'Osakeyhtiö'
      case Yritysmuoto.OSUUSKUNTA:
        return 'Osuuskunta'
      case Yritysmuoto.TOIMINIMI:
        return 'Toiminimi'
      case Yritysmuoto.YHDISTYS:
        return 'Yhdistys'
      default:
        return 'Tuntematon yhtiömuoto'
    }
  }

  chosenMonthHandlerKirjanpitajatAlku(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    asetaArvo(this.kirjanpitajatLomake.vuosikkalku, normalizedMonth)
    datepicker.close()
  }

  chosenMonthHandlerAlku(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    asetaArvo(this.lomake.vuosikkalku, normalizedMonth)
    datepicker.close()
  }

  chosenMonthHandlerLoppu(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    asetaArvo(this.lomake.vuosikkloppu, normalizedMonth)
    datepicker.close()
  }

  toggleNaytaPoistuneetKirjanpitajat() {
    this.naytaPoistuneetKirjanpitajatSubject.next(!this.naytaPoistuneetKirjanpitajatSubject.value)
  }

  // private getVuosiKkInternal(vuosikk: VuosiKk): string {
  //   if (vuosikk && vuosikk.vuosi && vuosikk.kohde && vuosikk.kk > -1) {
  //     return vuosikk.vuosi.toString().substring(2) + vuosikk.kohde + vuosikk.kk
  //   }
  //   return ''
  // }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  ngAfterViewInit() {
    this.kirjanpitajatDataSource.sort = this._sort
  }

  ngOnInit() {
    this._firebase.functionsCall<AnnaAsiakkaidenNimitiedotPyynto, AnnaAsiakkaidenNimitiedotVastaus>('annaAsiakkaidenNimitiedot', {}, { timeout: 540 * 1000 }).then(asiakkaatVastaus => {
      const m: { [avain: string]: AsiakkaanNimitiedot } = {}
      if (asiakkaatVastaus?.nimitiedot) {
        for (const a of asiakkaatVastaus.nimitiedot) {
          m[a.avain] = a
        }
      }
      this.asiakkaatMap = m
    })

    // this.kaikkiLaskutObservable.next(null)

    // const tanaan = this._dateService.dateToLocalDate(new Date())
    // const kuukausiSitten = this._dateService.lisaaKuukausiaPaikallinen(tanaan, -1)
    // const kaksiKuukauttaSitten = this._dateService.lisaaKuukausiaPaikallinen(tanaan, -2)
    // const kolmeKuukauttaSitten = this._dateService.lisaaKuukausiaPaikallinen(tanaan, -3)

    // const sorttaus = LaskunSorttaukset.ASIAKAS
    // const tilaS = '' // (tila && tila !== LaskunTila.kaikki) ? tila : ''
    // const vuosikkS1 = this.getVuosiKkInternal({ kk: kuukausiSitten.month, vuosi: kuukausiSitten.year, kohde: 'p' })
    // const vuosikkS3 = this.getVuosiKkInternal({ kk: kaksiKuukauttaSitten.month, vuosi: kaksiKuukauttaSitten.year, kohde: 'p' })
    // const vuosikkS2 = this.getVuosiKkInternal({ kk: kolmeKuukauttaSitten.month, vuosi: kolmeKuukauttaSitten.year, kohde: 'p' })
    // const vapaahakuS = '' // hakukriteerit.vapaahaku ? hakukriteerit.vapaahaku : ''
    // const hakuavain1 = sorttaus.tunniste + tilaS + vuosikkS1 + vapaahakuS
    // const hakuavain2 = sorttaus.tunniste + tilaS + vuosikkS2 + vapaahakuS
    // const hakuavain3 = sorttaus.tunniste + tilaS + vuosikkS3 + vapaahakuS
    // const searchProperty1 = 'haku.' + hakuavain1
    // const searchProperty2 = 'haku.' + hakuavain2
    // const searchProperty3 = 'haku.' + hakuavain3

    // const kk1Observable = this._firebaseLemonaid.firestoreCollection<Lasku>('/laskut/9/laskut').whereFree(searchProperty1, '>', '').orderByFree(searchProperty1, 'asc').listen()
    // const kk2Observable = this._firebaseLemonaid.firestoreCollection<Lasku>('/laskut/9/laskut').whereFree(searchProperty2, '>', '').orderByFree(searchProperty2, 'asc').listen()
    // const kk3Observable = this._firebaseLemonaid.firestoreCollection<Lasku>('/laskut/9/laskut').whereFree(searchProperty3, '>', '').orderByFree(searchProperty3, 'asc').listen()

    // this.kolmenViimeisenKuunLaskutObservable = combineLatest([kk1Observable, kk2Observable, kk3Observable]).pipe(
    //   map(kaikki => {
    //     kaikki[0].map(lasku => { delete lasku['haku'] })
    //     kaikki[1].map(lasku => { delete lasku['haku'] })
    //     kaikki[2].map(lasku => { delete lasku['haku'] })
    //     return [].concat(kaikki[0]).concat(kaikki[1]).concat(kaikki[2])
    //   })
    // )

    // this.duplikaattiLaskutObservable = this.kolmenViimeisenKuunLaskutObservable.pipe(
    //   map(laskut => {
    //     const duplikaatit: DuplikaattiLasku[] = []

    //     const m: { [key: string]: DuplikaattiLasku } = {}
    //     for (const lasku of laskut) {
    //       const avain = lasku.pvml.year + '_' + lasku.pvml.month + '_' + lasku.pvml.day + '_' + this._currencyService.formatoiRahaIlmanValuuttaSymboliaTaiRyhmittelya(lasku.summa, 'fi') + '_' + lasku.asiakas.avain
    //       if (m[avain]) {
    //         m[avain].lasku2 = lasku
    //         m[avain].laskunro2 = this._laskuSharedService.annaMuotoiltuLaskunumero(lasku, lasku)
    //       } else {
    //         m[avain] = { asiakas: lasku.asiakas, erapvm: lasku.erapvml, pvm: lasku.pvml, lasku1: lasku, lasku2: null, laskunro1: this._laskuSharedService.annaMuotoiltuLaskunumero(lasku, lasku), laskunro2: null }
    //       }
    //     }

    //     for (const avain of Object.keys(m)) {
    //       const duplikaatti = m[avain]
    //       if (duplikaatti.lasku1 && duplikaatti.lasku2) {
    //         duplikaatit.push(duplikaatti)
    //       }
    //     }

    //     return duplikaatit
    //   }),
    //   lemonShare()
    // )

    // this.duplikaatitLataavatObservable = this.duplikaattiLaskutObservable.pipe(
    //   map(duplikaatit => {
    //     return false
    //   }),
    //   startWith(true)
    // )

    this.kirjanpitajatDataSource.sortData = (data: AnnaAsiakkaidenTilastotiedotKirjanpitajittain[], sort: MatSort): AnnaAsiakkaidenTilastotiedotKirjanpitajittain[] => {
      const active = sort.active
      const direction = sort.direction

      // console.log('SORT', sort)

      if (!active || direction === '') {
        return data
      }

      const directionMultiplier = direction === 'asc' ? 1 : -1

      if (active === 'asiakkaita') {
        return data.sort((a, b) => {
          if (a.asiakkaita === null && b.asiakkaita === null) {
            return 0
          } else if (a.asiakkaita === null) {
            return 1 * directionMultiplier
          } else if (b.asiakkaita === null) {
            return -1 * directionMultiplier
          }
          return (a.asiakkaita - b.asiakkaita) * directionMultiplier
        })
      }

      if (active === 'keskimveloitus') {
        return data.sort((a, b) => {
          if (a.keskimaarainenVeloitus === null && b.keskimaarainenVeloitus === null) {
            return 0
          } else if (a.keskimaarainenVeloitus === null) {
            return 1 * directionMultiplier
          } else if (b.keskimaarainenVeloitus === null) {
            return -1 * directionMultiplier
          }
          return (a.keskimaarainenVeloitus - b.keskimaarainenVeloitus) * directionMultiplier
        })
      }

      if (active === 'jatkuvakk1') {
        return data.sort((a, b) => {
          if (a.jatkuvakk1 === null && b.jatkuvakk1 === null) {
            return 0
          } else if (a.jatkuvakk1 === null) {
            return 1 * directionMultiplier
          } else if (b.jatkuvakk1 === null) {
            return -1 * directionMultiplier
          }
          return (a.jatkuvakk1 - b.jatkuvakk1) * directionMultiplier
        })
      }

      if (active === 'jatkuvakk2') {
        return data.sort((a, b) => {
          if (a.jatkuvakk2 === null && b.jatkuvakk2 === null) {
            return 0
          } else if (a.jatkuvakk2 === null) {
            return 1 * directionMultiplier
          } else if (b.jatkuvakk2 === null) {
            return -1 * directionMultiplier
          }
          return (a.jatkuvakk2 - b.jatkuvakk2) * directionMultiplier
        })
      }

      if (active === 'lisaykset') {
        return data.sort((a, b) => {
          if (a.lisaykset === null && b.lisaykset === null) {
            return 0
          } else if (a.lisaykset === null) {
            return 1 * directionMultiplier
          } else if (b.lisaykset === null) {
            return -1 * directionMultiplier
          }
          return (a.lisaykset - b.lisaykset) * directionMultiplier
        })
      }

      if (active === 'vahennykset') {
        return data.sort((a, b) => {
          if (a.vahennykset === null && b.vahennykset === null) {
            return 0
          } else if (a.vahennykset === null) {
            return 1 * directionMultiplier
          } else if (b.vahennykset === null) {
            return -1 * directionMultiplier
          }
          return (a.vahennykset - b.vahennykset) * directionMultiplier
        })
      }

      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })
      if (active === 'yhtiomuodot') {
        return data.sort((a, b) => {
          if (a.yhtiomuodotTmi !== b.yhtiomuodotTmi) {
            return (a.yhtiomuodotTmi - b.yhtiomuodotTmi) * directionMultiplier
          } else if (a.yhtiomuodotOy !== b.yhtiomuodotOy) {
            return (a.yhtiomuodotOy - b.yhtiomuodotOy) * directionMultiplier
          } else if (a.yhtiomuodotMuut !== b.yhtiomuodotMuut) {
            return (a.yhtiomuodotMuut - b.yhtiomuodotMuut) * directionMultiplier
          }
          return 0
        })
      }

      if (active === 'kirjanpitaja') {
        return data.sort((a, b) => {
          return collator.compare(a.kirjanpitaja, b.kirjanpitaja) * directionMultiplier
        })
      }

      return data
    }

    this.asiakasInfoObservable = this.asiakkaatObservable.pipe(
      map(asiakkaat => {
        const paluuarvo: AsiakasInfo = {
          asiakkaita: 0,
          asiakkaitaJoillaHinta: 0,
          keskimaarainenhinta: 0,
          yhtiomuotojakauma: [],
        }
        const yhtiojakaumaMap: Map<string, { hinta: number; lukumaara: number }> = new Map()
        let hintaYhteensa = 0
        for (const asiakas of asiakkaat) {
          if (
            asiakas.k === 'uekRGWgeLqecXk0Gh8el0s85SEt1' || // Taneli Testinen
            asiakas.q || // Testiasiakas
            asiakas.s === AsiakkaanSopimuskaudenTila.PAATTYNYT ||
            // asiakas.s === AsiakkaanSopimuskaudenTila.POYTALAATIKOSSA ||
            asiakas.s === AsiakkaanSopimuskaudenTila.PURETTU
            // ||
            // asiakas.s === AsiakkaanSopimuskaudenTila.TAUOLLA ||
            // asiakas.s === AsiakkaanSopimuskaudenTila.PAATTYMASSA
          ) {
            continue
          }
          paluuarvo.asiakkaita++
          if (asiakas.h1) {
            hintaYhteensa += asiakas.h1
            paluuarvo.asiakkaitaJoillaHinta++
            const item = yhtiojakaumaMap.get(asiakas.y)
            if (item) {
              item.hinta += asiakas.h1
              item.lukumaara++
            } else {
              yhtiojakaumaMap.set(asiakas.y, {
                hinta: asiakas.h1,
                lukumaara: 1,
              })
            }
          }
        }

        if (paluuarvo.asiakkaitaJoillaHinta > 0) {
          paluuarvo.keskimaarainenhinta = hintaYhteensa / paluuarvo.asiakkaitaJoillaHinta
        }

        for (const [jakaumaAvain, jakaumatieto] of yhtiojakaumaMap.entries()) {
          paluuarvo.yhtiomuotojakauma.push({
            keskimaarainenHinta: jakaumatieto.lukumaara > 0 ? jakaumatieto.hinta / jakaumatieto.lukumaara : 0,
            maara: jakaumatieto.lukumaara,
            nimi: this.annaYhtiomuodonNimi(jakaumaAvain as Yritysmuoto),
          })
        }

        paluuarvo.yhtiomuotojakauma = paluuarvo.yhtiomuotojakauma.sort((a, b) => {
          return a.nimi.localeCompare(b.nimi)
        })

        return paluuarvo
      }),
    )

    this.asiakkaidenKuukausihintojenMuutoksetObservable = combineLatest([this.asiakkaatObservable, this._kirjanpitajaService.kirjanpitajienNimitiedotMapObservable]).pipe(
      map(([asiakkaat, kirjanpitajatMap]) => {
        const paluuarvo: AsiakkaanHinnanMuutokset[] = []

        for (const asiakas of asiakkaat) {
          if (asiakas.hm) {
            const asiakkaanPaluuarvo: AsiakkaanHinnanMuutokset = {
              asiakas: asiakas,
              hinnat: asiakas.hm,
              kirjanpitaja: kirjanpitajatMap.get(asiakas.k),
            }
            paluuarvo.push(asiakkaanPaluuarvo)
          }
        }

        paluuarvo.sort((a, b) => (a.asiakas.n ?? '').localeCompare(b.asiakas.n ?? ''))

        return paluuarvo
      }),
      lemonShare(),
    )

    this.asiakkaidenKuukausihintojenSummatObservable = this.asiakkaidenKuukausihintojenMuutoksetObservable.pipe(
      map(muutokset => {
        const summat: { localMonth: LocalMonth; poistuma: number; lisays: number; summa: number }[] = []
        if (muutokset && muutokset.length > 0) {
          const length = muutokset[0].hinnat.length
          for (let i = 0; i < length; i++) {
            summat[i] = { localMonth: muutokset[0].hinnat[i].localMonth, summa: 0, lisays: 0, poistuma: 0 }
          }
        }
        for (const asiakkaanHinnanMuutokset of muutokset) {
          const length = asiakkaanHinnanMuutokset.hinnat.length
          for (let i = 0; i < length; i++) {
            const muutos = asiakkaanHinnanMuutokset.hinnat[i].muutos || 0
            summat[i].summa += muutos
            if (muutos < 0) {
              summat[i].poistuma += muutos
            } else {
              summat[i].lisays += muutos
            }
          }
        }
        for (const summa of summat) {
          summa.lisays = summa.lisays === 0 ? null : summa.lisays
          summa.poistuma = summa.poistuma === 0 ? null : summa.poistuma
          summa.summa = summa.summa === 0 ? null : summa.summa
        }
        return summat
      }),
      lemonShare(),
    )

    // const laskutuksenMuutosKuukausittainObservable = combineLatest([this._valittuAikavaliObservable, this._rajauksetSubject]).pipe(
    //   switchMap(([aikavali, rajaukset]) => {
    //     const payload: AnnaLaskutusmuutosKuukausittainPyynto = {
    //       aikavali: aikavali,
    //       rajoitettuKirjanpitajaanAvain: rajaukset.kirjanpitaja ?? null,
    //       rajoitettuTiimiinAvain: rajaukset.tiimi ?? null,
    //       rajoitettuTiimiKokonaisuuteenAvain: rajaukset.tiimiKokonaisuus ?? null,
    //     }
    //     return this._firebase.functionsCall<AnnaLaskutusmuutosKuukausittainPyynto, AnnaLaskutusmuutosKuukausittainVastaus>('tilastotLaskutusKuukausittainMuutos', payload).then(vastaus => {
    //       return vastaus.muutosdata
    //     })
    //   }),
    //   lemonShare(),
    // )

    const jatkuvanLaskutuksenKehitysDataObservable = combineLatest([this._valittuAikavaliObservable, this._rajauksetSubject, this._valittuTagiSubject]).pipe(
      switchMap(([aikavali, rajaukset, tagiAvain]) => {
        this.valittuSolu.set(null)
        this.valitunSolunLahteet.set(null)

        const payload: JatkuvaKuukaudenLaskutusJakaumallaPyynto = {
          aikavali: aikavali,
          rajoitettuKirjanpitajaanAvain: rajaukset.kirjanpitaja ?? null,
          rajoitettuTiimiinAvain: rajaukset.tiimi ?? null,
          rajoitettuTiimiKokonaisuuteenAvain: rajaukset.tiimiKokonaisuus ?? null,
          rajoitettuTagiinAvain: tagiAvain ?? null,
        }
        return this._firebase.functionsCall<JatkuvaKuukaudenLaskutusJakaumallaPyynto, JatkuvanLaskutuksenKehitysVastaus>('tilastotJatkuvanLaskutuksenKehitys', payload).then(vastaus => {
          return vastaus.muutosdata
        })
      }),
      lemonShare(),
    )

    const myyntiYhteenVetoDataObservable = combineLatest([this._valittuAikavaliObservable, this._rajauksetSubject, this._valittuTagiSubject]).pipe(
      switchMap(([aikavali, rajaukset, tagiAvain]) => {
        this.valittuMyyntiyhteenvetoSolu.set(null)
        this.valitunMyyntiyhteenvetoSolunLahteet.set(null)

        const payload: JatkuvaKuukaudenLaskutusJakaumallaPyynto = {
          aikavali: aikavali,
          rajoitettuKirjanpitajaanAvain: rajaukset.kirjanpitaja ?? null,
          rajoitettuTiimiinAvain: rajaukset.tiimi ?? null,
          rajoitettuTiimiKokonaisuuteenAvain: rajaukset.tiimiKokonaisuus ?? null,
          rajoitettuTagiinAvain: tagiAvain ?? null,
        }
        return this._firebase.functionsCall<JatkuvaKuukaudenLaskutusJakaumallaPyynto, MyyntiYhteenvetoVastaus>('tilastotMyyntiYhteenveto', payload).then(vastaus => {
          return vastaus.kuukausidata
        })
      }),
      lemonShare(),
    )

    this.myyntiYhteenvetoObservable = myyntiYhteenVetoDataObservable.pipe(
      map(kuukausidata => {
        const tuoteAvainToNimi = new Map<string, string>()
        const tuotteetMap = new Map<string, string | null>()

        for (const data of kuukausidata) {
          for (const tuote of data.tuotteet) {
            if (!tuotteetMap.has(tuote.nimi) || tuote.tuote !== null) {
              tuotteetMap.set(tuote.nimi, tuote.tuote)
            }
            if (tuote.tuote) {
              tuoteAvainToNimi.set(tuote.tuote, tuote.nimi)
            }
          }
        }
        // Otsikko
        const otsikkorivi: MyyntiyhteenvetoRivi = {
          cols: [{ arvo: null }, ...kuukausidata.map(d => ({ arvo: d.kuukausi + '/' + d.vuosi })), { arvo: 'Yhteensä' }],
          bold: false,
          nimi: null,
        }

        const myyntiKaikki = kuukausidata.reduce((total, d) => total + (d.myyntiYhteensa?.myynti ?? 0), 0)
        const myyntiHyvityksetKaikki = kuukausidata.reduce((total, d) => total + (d.myyntiYhteensa?.hyvitykset ?? 0), 0)
        const myyntiYhteensaKaikki = kuukausidata.reduce((total, d) => total + (d.myyntiYhteensa?.yhteensa ?? 0), 0)

        const palvelumyyntiKaikki = kuukausidata.reduce((total, d) => total + (d.palvelumyyntiYhteensa?.myynti ?? 0), 0)
        const palvelumyyntiHyvityksetKaikki = kuukausidata.reduce((total, d) => total + (d.palvelumyyntiYhteensa?.hyvitykset ?? 0), 0)
        const palvelumyyntiYhteensaKaikki = kuukausidata.reduce((total, d) => total + (d.palvelumyyntiYhteensa?.yhteensa ?? 0), 0)

        const rivit: MyyntiyhteenvetoRivi[] = [otsikkorivi]

        // Myynti yhteensä -rivi
        const myyntiNimi = 'Myynti'
        const myyntiYhteensaNimi = 'Myynti yhteensä'
        const myyntiHyvityksetNimi = 'Myynti (hyvitykset)'
        const myyntiYhteensaKategoriaAvain = 'myynti-yhteensa'

        const myyntiYhteensaCols = kuukausidata.map(d => ({
          arvo: this._currencyService.formatoiRaha(d.myyntiYhteensa?.yhteensa ?? 0, 'EUR', 'fi'),
          vuosi: d.vuosi,
          kuukausi: d.kuukausi,
          tuote: 'kaikki',
          onHyvitys: myyntiHyvityksetKaikki !== 0 ? undefined : false,
        }))

        rivit.push({
          cols: [{ arvo: myyntiYhteensaNimi }, ...myyntiYhteensaCols, { arvo: this._currencyService.formatoiRaha(myyntiYhteensaKaikki, 'EUR', 'fi') }],
          bold: true,
          nimi: myyntiYhteensaNimi,
          kategoriaAvain: myyntiHyvityksetKaikki !== 0 ? myyntiYhteensaKategoriaAvain : undefined,
          onKlikattavaKategoria: true,
          onYhteensaRivi: true,
        })

        // Jos on hyvityksiä, lisää alakategoriat
        if (myyntiHyvityksetKaikki !== 0) {
          rivit.push({
            cols: [
              { arvo: myyntiNimi },
              ...kuukausidata.map(d => {
                const summa = d.myyntiYhteensa?.myynti ?? 0
                return {
                  arvo: this._currencyService.formatoiRaha(summa, 'EUR', 'fi'),
                  summa,
                  vuosi: d.vuosi,
                  kuukausi: d.kuukausi,
                  tuote: 'kaikki',
                  onHyvitys: false,
                }
              }),
              { arvo: this._currencyService.formatoiRaha(myyntiKaikki, 'EUR', 'fi') },
            ],
            bold: false,
            nimi: myyntiNimi,
            kuuluuKategoriaan: myyntiYhteensaKategoriaAvain,
            onAlakategoria: true,
          })

          rivit.push({
            cols: [
              { arvo: myyntiHyvityksetNimi },
              ...kuukausidata.map(d => {
                const summa = d.myyntiYhteensa?.hyvitykset ?? 0
                return {
                  arvo: this._currencyService.formatoiRaha(summa, 'EUR', 'fi'),
                  summa,
                  vuosi: d.vuosi,
                  kuukausi: d.kuukausi,
                  tuote: 'kaikki',
                  onHyvitys: true,
                }
              }),
              { arvo: this._currencyService.formatoiRaha(myyntiHyvityksetKaikki, 'EUR', 'fi') },
            ],
            bold: false,
            nimi: myyntiHyvityksetNimi,
            kuuluuKategoriaan: myyntiYhteensaKategoriaAvain,
            onAlakategoria: true,
          })
        }

        const palvelumyyntiNimi = 'Palvelumyynti'
        const palvelumyyntiYhteensaNimi = 'Palvelumyynti yhteensä'
        const palvelumyyntiHyvityksetNimi = 'Palvelumyynti (hyvitykset)'
        const palvelumyyntiYhteensaKategoriaAvain = 'palvelumyynti-yhteensa'

        const palvelumyyntiYhteensaCols = kuukausidata.map(d => ({
          arvo: this._currencyService.formatoiRaha(d.palvelumyyntiYhteensa?.yhteensa ?? 0, 'EUR', 'fi'),
          vuosi: d.vuosi,
          kuukausi: d.kuukausi,
          tuote: 'kaikki',
          onHyvitys: palvelumyyntiHyvityksetKaikki !== 0 ? undefined : false,
          onPalvelumyynti: true,
        }))

        rivit.push({
          cols: [{ arvo: palvelumyyntiYhteensaNimi }, ...palvelumyyntiYhteensaCols, { arvo: this._currencyService.formatoiRaha(palvelumyyntiYhteensaKaikki, 'EUR', 'fi') }],
          bold: true,
          nimi: palvelumyyntiYhteensaNimi,
          kategoriaAvain: palvelumyyntiHyvityksetKaikki !== 0 ? palvelumyyntiYhteensaKategoriaAvain : undefined,
          onKlikattavaKategoria: true,
          onYhteensaRivi: true,
        })

        // Jos on hyvityksiä, lisää alakategoriat
        if (palvelumyyntiHyvityksetKaikki !== 0) {
          rivit.push({
            cols: [
              { arvo: palvelumyyntiNimi },
              ...kuukausidata.map(d => {
                const summa = d.palvelumyyntiYhteensa?.myynti ?? 0
                return {
                  arvo: this._currencyService.formatoiRaha(summa, 'EUR', 'fi'),
                  summa,
                  vuosi: d.vuosi,
                  kuukausi: d.kuukausi,
                  tuote: 'kaikki',
                  onHyvitys: false,
                  onPalvelumyynti: true,
                }
              }),
              { arvo: this._currencyService.formatoiRaha(palvelumyyntiKaikki, 'EUR', 'fi') },
            ],
            bold: false,
            nimi: palvelumyyntiNimi,
            kuuluuKategoriaan: palvelumyyntiYhteensaKategoriaAvain,
            onAlakategoria: true,
          })

          rivit.push({
            cols: [
              { arvo: palvelumyyntiHyvityksetNimi },
              ...kuukausidata.map(d => {
                const summa = d.palvelumyyntiYhteensa?.hyvitykset ?? 0
                return {
                  arvo: this._currencyService.formatoiRaha(summa, 'EUR', 'fi'),
                  summa,
                  vuosi: d.vuosi,
                  kuukausi: d.kuukausi,
                  tuote: 'kaikki',
                  onHyvitys: true,
                  onPalvelumyynti: true,
                }
              }),
              { arvo: this._currencyService.formatoiRaha(palvelumyyntiHyvityksetKaikki, 'EUR', 'fi') },
            ],
            bold: false,
            nimi: palvelumyyntiHyvityksetNimi,
            kuuluuKategoriaan: palvelumyyntiYhteensaKategoriaAvain,
            onAlakategoria: true,
          })
        }

        const kategoriatMap = new Map<string, { nimi: string; tuotteet: { nimi: string; jarjestys: number; avain: string }[] }>()
        const kasitellytTuotteet = new Set<string>()

        for (const tuotenimike of tuotenimikkeet) {
          if (!tuotenimike.tilastoKategoria) {
            continue
          }
          const kategoriaAvain = tuotenimike.tilastoKategoria
          if (!kategoriatMap.has(kategoriaAvain)) {
            kategoriatMap.set(kategoriaAvain, { nimi: kategoriaAvain, tuotteet: [] })
          }
          const tuoteNimi = tuoteAvainToNimi.get(tuotenimike.avain)
          if (tuoteNimi) {
            kategoriatMap.get(kategoriaAvain).tuotteet.push({
              nimi: tuoteNimi,
              jarjestys: tuotenimike.tilastoJarjestys ?? 9999,
              avain: tuotenimike.avain,
            })
            kasitellytTuotteet.add(tuoteNimi)
          }
        }

        const muutTuotteet = Array.from(tuotteetMap.keys()).filter(nimi => !kasitellytTuotteet.has(nimi))
        if (muutTuotteet.length > 0) {
          if (!kategoriatMap.has(MUU_LASKUTUS)) {
            kategoriatMap.set(MUU_LASKUTUS, { nimi: MUU_LASKUTUS, tuotteet: [] })
          }
          for (const tuoteNimi of muutTuotteet) {
            kategoriatMap.get(MUU_LASKUTUS).tuotteet.push({
              nimi: tuoteNimi,
              jarjestys: 10000,
              avain: tuotteetMap.get(tuoteNimi) || '',
            })
          }
        }

        const jarjestetytKategoriat = Array.from(kategoriatMap.entries())
          .map(([avain, data]) => ({
            avain,
            nimi: data.nimi,
            tuotteet: data.tuotteet.sort((a, b) => a.jarjestys - b.jarjestys),
            minJarjestys: Math.min(...data.tuotteet.map(t => t.jarjestys)),
          }))
          .sort((a, b) => a.minJarjestys - b.minJarjestys)

        for (const kategoria of jarjestetytKategoriat) {
          if (kategoria.tuotteet.length === 0) {
            continue
          }

          const tuoteNimetSet = new Set(kategoria.tuotteet.map(t => t.nimi))
          const onKlikattava = kategoria.nimi === MUU_LASKUTUS

          let yhteensa = 0
          let hyvityksetYhteensa = 0
          const cols = kuukausidata.map(d => {
            const summa = d.tuotteet.filter(t => tuoteNimetSet.has(t.nimi) && !t.onHyvitys).reduce((sum, t) => sum + t.summa, 0)
            const hyvitykset = d.tuotteet.filter(t => tuoteNimetSet.has(t.nimi) && t.onHyvitys).reduce((sum, t) => sum + t.summa, 0)
            yhteensa += summa
            hyvityksetYhteensa += hyvitykset

            const naytettavaSumma = summa + hyvitykset
            return {
              arvo: this._currencyService.formatoiRaha(naytettavaSumma, 'EUR', 'fi'),
              vuosi: d.vuosi,
              kuukausi: d.kuukausi,
              tuote: onKlikattava ? (tuotteetMap.get(kategoria.tuotteet[0].nimi) ?? null) : undefined,
            }
          })

          const naytettavaYhteensa = yhteensa + hyvityksetYhteensa
          rivit.push({
            cols: [{ arvo: kategoria.nimi }, ...cols, { arvo: this._currencyService.formatoiRaha(naytettavaYhteensa, 'EUR', 'fi') }],
            bold: true,
            nimi: onKlikattava ? kategoria.tuotteet[0].nimi : kategoria.nimi,
            kategoriaAvain: kategoria.avain,
            onKlikattavaKategoria: onKlikattava,
          })

          if (onKlikattava) {
            continue
          }

          for (const tuote of kategoria.tuotteet) {
            const tuoteRivinAvain = tuotteetMap.get(tuote.nimi) ?? null

            let tuoteYhteensa = 0
            let tuoteHyvityksetYhteensa = 0

            // Laske normaalit ja hyvitykset
            const tuoteCols = kuukausidata.map(d => {
              const tuoteData = d.tuotteet.find(t => t.nimi === tuote.nimi && !t.onHyvitys)
              const summa = tuoteData?.summa ?? 0
              tuoteYhteensa += summa
              return {
                arvo: this._currencyService.formatoiRaha(summa, 'EUR', 'fi'),
                summa,
                vuosi: d.vuosi,
                kuukausi: d.kuukausi,
                tuote: tuoteRivinAvain,
                onHyvitys: false,
              }
            })

            const hyvityksetCols = kuukausidata.map(d => {
              const hyvitysData = d.tuotteet.find(t => t.nimi === tuote.nimi && t.onHyvitys)
              const summa = hyvitysData?.summa ?? 0
              tuoteHyvityksetYhteensa += summa
              return {
                arvo: this._currencyService.formatoiRaha(summa, 'EUR', 'fi'),
                summa,
                vuosi: d.vuosi,
                kuukausi: d.kuukausi,
                tuote: tuoteRivinAvain,
                onHyvitys: true,
              }
            })

            // Jos on hyvityksiä, luo yhteensä-rivi ja alakategoriat
            if (tuoteHyvityksetYhteensa !== 0) {
              const tuoteYhteensaNimi = tuote.nimi + ' yhteensä'
              const tuoteHyvityksetNimi = tuote.nimi + ' (hyvitykset)'

              const yhteensaCols = kuukausidata.map((d, i) => {
                const yhteensaSumma = tuoteCols[i].summa + hyvityksetCols[i].summa
                return {
                  arvo: this._currencyService.formatoiRaha(yhteensaSumma, 'EUR', 'fi'),
                  summa: yhteensaSumma,
                  vuosi: d.vuosi,
                  kuukausi: d.kuukausi,
                  tuote: tuoteRivinAvain,
                  onHyvitys: undefined,
                }
              })

              rivit.push({
                cols: [{ arvo: tuoteYhteensaNimi }, ...yhteensaCols, { arvo: this._currencyService.formatoiRaha(tuoteYhteensa + tuoteHyvityksetYhteensa, 'EUR', 'fi') }],
                bold: true,
                nimi: tuoteYhteensaNimi,
                kuuluuKategoriaan: kategoria.avain,
                onYhteensaRivi: true,
              })

              rivit.push({
                cols: [{ arvo: tuote.nimi }, ...tuoteCols, { arvo: this._currencyService.formatoiRaha(tuoteYhteensa, 'EUR', 'fi') }],
                bold: false,
                nimi: tuote.nimi,
                kuuluuKategoriaan: kategoria.avain,
                onAlakategoria: true,
              })

              rivit.push({
                cols: [{ arvo: tuoteHyvityksetNimi }, ...hyvityksetCols, { arvo: this._currencyService.formatoiRaha(tuoteHyvityksetYhteensa, 'EUR', 'fi') }],
                bold: false,
                nimi: tuoteHyvityksetNimi,
                kuuluuKategoriaan: kategoria.avain,
                onAlakategoria: true,
              })
            } else {
              rivit.push({
                cols: [{ arvo: tuote.nimi }, ...tuoteCols, { arvo: this._currencyService.formatoiRaha(tuoteYhteensa, 'EUR', 'fi') }],
                bold: false,
                nimi: tuote.nimi,
                kuuluuKategoriaan: kategoria.avain,
              })
            }
          }
        }

        return rivit
      }),
      tap(() => {
        this.myyntiyhteenvetoTableLataa.set(false)
      }),
    )

    this.jatkuvanLaskutuksenKehitysObservable = jatkuvanLaskutuksenKehitysDataObservable.pipe(
      map(kuukausidata => {
        const kuukausiRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], bold: false }
        const edellisenKuukaudenSaldoRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Edellisen kuukauden loppusaldo', bold: false }
        const kkAlussaRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Kk:n alussa voimaan tulleet muutokset (yht)', bold: true }
        const paattyneetSopimuksetRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Päättyneet sopimukset', bold: false, offset: true }
        const poytalaatikkoonMenneetRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Pöytälaatikkoon menneet', bold: false, offset: true }
        const poytalaatikostaTulleetRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Pöytälaatikosta tulleet', bold: false, offset: true }
        const tauolleMenneetRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Tauolle menneet', bold: false, offset: true }
        const tauoltaTulleetRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Tauolta tulleet', bold: false, offset: true }
        const hinnanKorotuksetRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Hinnankorotukset', bold: false, offset: true }
        const hinnanAlennuksetRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Hinnan alennukset', bold: false, offset: true }
        const sisaisetSiirrotPlusRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Sisäiset siirrot +', bold: false, offset: true }
        const sisaisetSiirrotMiinusRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Sisäiset siirrot -', bold: false, offset: true }
        const tagirajaukseenTulleetRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Tagirajaukseen tulleet', bold: false, offset: true }
        const tagirajauksestaPoistuneetRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], nimi: 'Tagirajauksesta poistuneet', bold: false, offset: true }
        const alkaneetSopimuksetRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], bold: true, nimi: 'Alkaneet sopimukset', divider: true }
        const jatkuvaLaskutusYhteensaRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], bold: false, nimi: 'Jatkuva laskutus yhteensä', grey: true }
        const muutosEdelliseenKkRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], bold: false, nimi: 'Muutos edelliseen kuukauteen' }
        const poistumaYhteensaRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], bold: false, nimi: 'Poistuma yhteensä' }
        const lisaysYhteensaRivi: JatkuvaLaskutusKuukausittaisenTablenRivi = { cols: [], bold: false, nimi: 'Lisäys yhteensä' }

        const solu = (data: JatkuvanLaskutuksenKehitysTiedot, kentta: JatkuvanLaskutuksenKehitysKentta, muutos: LaskutuksenMuutos | undefined): KuukausittaisenSolunData => {
          const summa = muutos?.summa ?? 0
          const kpl = muutos?.kpl ?? 0
          return {
            arvo: `${this._currencyService.formatoiRaha(summa, 'EUR', 'fi')} (${kpl} kpl)`,
            vuosi: data.vuosi,
            kuukausi: data.kuukausi,
            kentta,
            summa,
            kpl,
          }
        }

        for (const data of kuukausidata) {
          kuukausiRivi.cols.push({ arvo: data.kuukausi + '/' + data.vuosi, vuosi: data.vuosi, kuukausi: data.kuukausi })

          edellisenKuukaudenSaldoRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.EDELLISEN_KK_LOPPUSALDO, data.edellinenKkLoppu))
          kkAlussaRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.KK_ALUSSA, data.kkAlussaVoimaantulleet))
          paattyneetSopimuksetRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.PAATTYNEET_SOPIMUKSET, data.paattyneetSopimukset))
          poytalaatikkoonMenneetRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.POYTALAATIKKOON_MENNEET, data.poytalaatikkoonMenneet))
          poytalaatikostaTulleetRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.POYTALAATIKOSTA_TULLEET, data.poytalaatikostaTulleet))
          tauolleMenneetRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.TAUOLLE_MENNEET, data.tauolleMenneet))
          tauoltaTulleetRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.TAUOLTA_TULLEET, data.tauoltaTulleet))
          hinnanKorotuksetRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.HINNAN_KOROTUKSET, data.hinnanKorotukset))
          hinnanAlennuksetRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.HINNAN_ALENNUKSET, data.hinnanAlennukset))
          sisaisetSiirrotPlusRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.SISAISET_SIIRROT_PLUS, data.sisaisetSiirrotPlus))
          sisaisetSiirrotMiinusRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.SISAISET_SIIRROT_MIINUS, data.sisaisetSiirrotMiinus))
          tagirajaukseenTulleetRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.TAGIRAJAUKSEEN_TULLEET, data.tagirajaukseenTulleet))
          tagirajauksestaPoistuneetRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.TAGIRAJAUKSESTA_POISTUNEET, data.tagirajauksestaPoistuneet))
          alkaneetSopimuksetRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.ALKANEET_SOPIMUKSET, data.alkaneetSopimukset))
          jatkuvaLaskutusYhteensaRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.JATKUVA_LASKUTUS_YHTEENSA, data.jatkuvaLaskutusYhteensa))
          muutosEdelliseenKkRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.MUUTOS_EDELLISEEN_KK, data.muutosEdelliseenKk))
          poistumaYhteensaRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.POISTUMA_YHTEENSA, data.poistumaYhteensa))
          lisaysYhteensaRivi.cols.push(solu(data, JatkuvanLaskutuksenKehitysKentta.LISAYS_YHTEENSA, data.lisaysYhteensa))
        }

        const naytaTagirajausRivit = kuukausidata.some(data => !!data.tagirajaukseenTulleet || !!data.tagirajauksestaPoistuneet)

        const rivit: JatkuvaLaskutusKuukausittaisenTablenRivi[] = [
          kuukausiRivi,
          edellisenKuukaudenSaldoRivi,
          kkAlussaRivi,
          paattyneetSopimuksetRivi,
          poytalaatikkoonMenneetRivi,
          poytalaatikostaTulleetRivi,
          tauolleMenneetRivi,
          tauoltaTulleetRivi,
          hinnanKorotuksetRivi,
          hinnanAlennuksetRivi,
          sisaisetSiirrotPlusRivi,
          sisaisetSiirrotMiinusRivi,
          ...(naytaTagirajausRivit ? [tagirajaukseenTulleetRivi, tagirajauksestaPoistuneetRivi] : []),
          alkaneetSopimuksetRivi,
          jatkuvaLaskutusYhteensaRivi,
          muutosEdelliseenKkRivi,
          poistumaYhteensaRivi,
          lisaysYhteensaRivi,
        ]

        return rivit
      }),
      tap(() => {
        this.jatkuvanLaskutuksenKehitysTableLataa.set(false)
      }),
    )

    this.jatkuvanLaskutuksenPeriodinLoppuKplObservable = jatkuvanLaskutuksenKehitysDataObservable.pipe(
      map(kuukausidata => {
        if (!kuukausidata || kuukausidata.length === 0) {
          return 0
        }
        const nykyinenKuukausi = this._dateService.currentLocalMonth()
        const menneisyydenJaNykyisetKuukaudet = kuukausidata.filter(k => {
          if (k.vuosi < nykyinenKuukausi.year) {
            return true
          }
          if (k.vuosi > nykyinenKuukausi.year) {
            return false
          }
          return k.kuukausi <= nykyinenKuukausi.month
        })

        if (menneisyydenJaNykyisetKuukaudet.length === 0) {
          return 0
        }
        const viimeisinMenneisyydessa = menneisyydenJaNykyisetKuukaudet[menneisyydenJaNykyisetKuukaudet.length - 1]
        return viimeisinMenneisyydessa.jatkuvaLaskutusYhteensa.kpl
      }),
    )

    this.periodinLoppuInfoObservable = jatkuvanLaskutuksenKehitysDataObservable.pipe(
      map(kuukausidata => {
        const paluuarvo: PeriodinLoppuInfo = {
          asiakkaita: 0,
          liikevaihto: 0,
          keskihinta: 0,
          yhtiomuotojakauma: [],
          kuukausi: 0,
          vuosi: 0,
          tauolla: 0,
          poytalaatikossa: 0,
        }

        if (!kuukausidata || kuukausidata.length === 0) {
          return paluuarvo
        }

        const viimeisinKuukausi = kuukausidata[kuukausidata.length - 1]
        paluuarvo.asiakkaita = viimeisinKuukausi.jatkuvaLaskutusYhteensa.kpl
        paluuarvo.liikevaihto = viimeisinKuukausi.jatkuvaLaskutusYhteensa.summa
        paluuarvo.kuukausi = viimeisinKuukausi.kuukausi
        paluuarvo.vuosi = viimeisinKuukausi.vuosi % 100

        if (paluuarvo.asiakkaita > 0) {
          paluuarvo.keskihinta = paluuarvo.liikevaihto / paluuarvo.asiakkaita
        }

        if (viimeisinKuukausi.yhtiomuotojakauma) {
          const tulos: { nimi: string; maara: number }[] = []
          for (const [yhtiomuoto, maara] of Object.entries(viimeisinKuukausi.yhtiomuotojakauma)) {
            tulos.push({
              nimi: this.annaYhtiomuodonNimi(yhtiomuoto as Yritysmuoto),
              maara,
            })
          }
          paluuarvo.yhtiomuotojakauma = tulos.sort((a, b) => a.nimi.localeCompare(b.nimi))
        }

        if (viimeisinKuukausi.tauollaOlevatAsiakkaat) {
          paluuarvo.tauolla = viimeisinKuukausi.tauollaOlevatAsiakkaat.tauolla
          paluuarvo.poytalaatikossa = viimeisinKuukausi.tauollaOlevatAsiakkaat.poytalaatikossa
        }

        return paluuarvo
      }),
    )

    // this.kuukausittainenJakaumaObservable = combineLatest([
    //   this._valittuAikavaliObservable, // .pipe(tap((t) => console.log('_valittuAikavaliObservable changed', t))),
    //   this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable, // .pipe(tap((t) => console.log('kirjanpitajanTiedotObservable changed', t))),
    //   this._rajauksetSubject, // .pipe(tap((t) => console.log('_rajauksetSubject changed', t)))
    //   this.naytaTarkkaJakaumaFormControl.valueChanges.pipe(startWith(this.naytaTarkkaJakaumaFormControl.value)),
    // ]).pipe(
    //   switchMap(([aikavali, kirjanpitajanTiedot, rajaukset, tarkkajakauma]) => {
    //     if (aikavali && kirjanpitajanTiedot) {
    //       const pyynto: AnnaKuukaudenLaskutusJakaumallaPyynto = {
    //         aikavali: aikavali,
    //         palautaLahteet: tarkkajakauma,
    //         rajoitettuKirjanpitajaanAvain: kirjanpitajanTiedot.uid,
    //         rajoitettuTiimiinAvain: rajaukset.tiimi ?? null,
    //       }

    //       if (kirjanpitajanTiedot.rooli === KirjanpitajanRooli.SUPER) {
    //         if (rajaukset.kirjanpitaja) {
    //           pyynto.rajoitettuKirjanpitajaanAvain = rajaukset.kirjanpitaja
    //         } else {
    //           pyynto.rajoitettuKirjanpitajaanAvain = null
    //         }
    //       }

    //       return this._firebase.functionsCall<AnnaKuukaudenLaskutusJakaumallaPyynto, AnnaKuukaudenLaskutusJakaumallaVastaus>('tilastotLaskutusKuukausittain', pyynto).then(vastaus => {
    //         return vastaus?.jakaumadata ?? []
    //       })
    //     }

    //     return observableOf<KuukaudenLaskutusJakaumallaTiedot[]>([])
    //   }),
    //   lemonShare(),
    // )

    // const viimeinen30PvRaakadataObservable = combineLatest([this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable, this._rajauksetSubject]).pipe(
    //   switchMap(([kirjanpitajanTiedot, rajaukset]) => {
    //     if (kirjanpitajanTiedot?.rooli === KirjanpitajanRooli.SUPER) {
    //       const end = this._dateService.dateToLocalDate(new Date())
    //       const start = this._dateService.lisaaPaiviaPaikallinen(end, -30)
    //       const pyynto: AnnaKuukaudenLaskutusKirjanpitajittainJakaumallaPyynto = {
    //         aikavali: {
    //           end: end,
    //           start: start
    //         },
    //         palautaLahteet: false,
    //         rajoitettuKirjanpitajaanAvain: null,
    //         rajoitettuTiimiinAvain: rajaukset.tiimi ?? null
    //       }

    //       return this._firebase.functionsCall<AnnaKuukaudenLaskutusKirjanpitajittainJakaumallaPyynto, AnnaKuukaudenLaskutusKirjanpitajittainJakaumallaVastaus>('tilastotLaskutusKirjanpitajittainKuukausittain', pyynto)
    //         .then(vastaus => {
    //           return vastaus?.jakaumadata ?? []
    //         })
    //     }
    //     return observableOf<KuukaudenLaskutusKirjanpitajittainJakaumallaTiedot[]>([])
    //   })
    // )

    // const kirjanpitajittainDataObservable = combineLatest([
    //   this._valittuAikavaliObservable,
    //   this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable,
    //   this._rajauksetSubject,
    //   this.naytaTarkkaJakaumaKirjanpitajatFormControl.valueChanges.pipe(startWith(this.naytaTarkkaJakaumaKirjanpitajatFormControl.value)),
    // ]).pipe(
    //   switchMap(([aikavali, kirjanpitajanTiedot, rajaukset, tarkkajakauma]) => {
    //     if (aikavali && kirjanpitajanTiedot) {
    //       const pyynto: AnnaKuukaudenLaskutusKirjanpitajittainJakaumallaPyynto = {
    //         aikavali: aikavali,
    //         palautaLahteet: tarkkajakauma,
    //         rajoitettuKirjanpitajaanAvain: kirjanpitajanTiedot.uid,
    //         rajoitettuTiimiinAvain: rajaukset.tiimi ?? null,
    //       }

    //       if (kirjanpitajanTiedot.rooli === KirjanpitajanRooli.SUPER) {
    //         if (rajaukset.kirjanpitaja) {
    //           pyynto.rajoitettuKirjanpitajaanAvain = rajaukset.kirjanpitaja
    //         } else {
    //           pyynto.rajoitettuKirjanpitajaanAvain = null
    //         }
    //       }

    //       return this._firebase
    //         .functionsCall<AnnaKuukaudenLaskutusKirjanpitajittainJakaumallaPyynto, AnnaKuukaudenLaskutusKirjanpitajittainJakaumallaVastaus>('tilastotLaskutusKirjanpitajittainKuukausittain', pyynto)
    //         .then(vastaus => {
    //           return vastaus?.jakaumadata ?? []
    //         })
    //     }

    //     return observableOf<KuukaudenLaskutusKirjanpitajittainJakaumallaTiedot[]>([])
    //   }),
    // )

    // this.kirjanpitajittainJakaumaObservable = combineLatest([this._kirjanpitajaService.kirjanpitajienNimitiedotMapObservable, kirjanpitajittainDataObservable]).pipe(
    //   map(([kirjanpitajatMap, tiedot]) => {
    //     for (const kuukaudenTiedot of tiedot) {
    //       const kirjanpitaja = kirjanpitajatMap.get(kuukaudenTiedot.kirjanpitajanAvain)
    //       if (kirjanpitaja) {
    //         kuukaudenTiedot.kirjanpitaja = kirjanpitaja.etunimi + ' ' + kirjanpitaja.sukunimi
    //       }
    //     }

    //     return tiedot.sort((a, b) => {
    //       if (a.kirjanpitaja !== b.kirjanpitaja) {
    //         return a.kirjanpitaja.localeCompare(b.kirjanpitaja)
    //       }
    //       if (a.vuosi !== b.vuosi) {
    //         return a.vuosi - b.vuosi
    //       }
    //       return a.kuukausi - b.kuukausi
    //     })
    //   }),
    // )

    // combineLatest([viimeinen30PvRaakadataObservable, this._kirjanpitajaService.kirjanpitajienNimitiedotObservable, this.asiakkaatObservable, this._rajauksetSubject]).pipe(
    //   switchMap(async ([laskutusViim30pv, kirjanpitajat, asiakkaat, rajaukset]) => {

    //     const tiimi = rajaukset.tiimi ? await this._kirjanpitajanTiimiService.annaTiimi(rajaukset.tiimi) : null
    //     const tiimiSet = tiimi ? this._kirjanpitajanTiimiService.annaTiiminKirjanpitajatPaivalleSet(tiimi, this._dateService.currentNumberDate()) : null
    //     const paluuarvo: KirjanpitajatTablenTiedot[] = []
    //     for (const kirjanpitaja of kirjanpitajat) {

    //       if (tiimiSet && !tiimiSet.has(kirjanpitaja.avain)) {
    //         continue
    //       }

    //       let kertalaskutus = 0
    //       for (const raakadata of laskutusViim30pv) {
    //         if (raakadata.kirjanpitajanAvain === kirjanpitaja.avain) {
    //           kertalaskutus += raakadata.kertalaskutus
    //         }
    //       }

    //       let voimassaolevat = 0
    //       let muutosTulevaisuudessa = 0
    //       let asiakkaita = 0
    //       let toiminimia = 0
    //       let osakeyhtioita = 0
    //       let muitaYrityksia = 0
    //       for (const asiakas of asiakkaat) {
    //         if (asiakas.k === kirjanpitaja.avain) {
    //           if (asiakas.h1) {
    //             asiakkaita++
    //             voimassaolevat += asiakas.h1
    //             if (asiakas.y === Yritysmuoto.OSAKEYHTIO) {
    //               osakeyhtioita++
    //             } else if (asiakas.y === Yritysmuoto.TOIMINIMI) {
    //               toiminimia++
    //             } else {
    //               muitaYrityksia++
    //             }
    //           }
    //           if (asiakas.h2) {
    //             if (asiakas.h1) {
    //               muutosTulevaisuudessa += (asiakas.h1 - asiakas.h2)
    //             } else {
    //               muutosTulevaisuudessa += asiakas.h2
    //             }
    //           }
    //         }
    //       }

    //       paluuarvo.push({
    //         kirjanpitaja: kirjanpitaja,
    //         asiakkaita: asiakkaita,
    //         jatkuvaVeloitus: voimassaolevat,
    //         kate: 0,
    //         kertalaskutuksetViimeinen30Pv: kertalaskutus,
    //         keskimaarainenVeloitus: asiakkaita > 0 ? voimassaolevat / asiakkaita : 0,
    //         tulevatMuutokset: muutosTulevaisuudessa,
    //         yhtiomuodot: [toiminimia, osakeyhtioita, muitaYrityksia],
    //         yhtiomuotoString: toiminimia + '/' + osakeyhtioita + '/' + muitaYrityksia
    //       })

    //     }

    //     return paluuarvo
    //   }),
    //   takeUntil(this.ngUnsubscribe)
    // ).subscribe(tiedot => {
    //   this.kirjanpitajatDataSource.filter = null
    //   this.kirjanpitajatDataSource.data = tiedot
    // })
    const kirjanpitajienRaakadataObservable = combineLatest([this._valittuKirjanpitajienAikavaliSubject, this._rajauksetSubject, this._valittuAikavaliObservable, this._valittuTagiSubject]).pipe(
      switchMap(([kirjanpitajatAikavali, rajaukset, aikavali, tagiAvain]) => {
        const payload: AnnaAsiakkaidenTilastotiedotKirjanpitajittainPyynto = {
          kuukausi: kirjanpitajatAikavali.start,
          rajoitettuKirjanpitajaanAvain: rajaukset.kirjanpitaja ?? null,
          rajoitettuTiimiinAvain: rajaukset.tiimi ?? null,
          kuukausiAlku: aikavali.start,
          kuukausiLoppu: aikavali.end,
          rajoitettuTagiinAvain: tagiAvain ?? null,
        }
        return this._firebase
          .functionsCall<AnnaAsiakkaidenTilastotiedotKirjanpitajittainPyynto, AnnaAsiakkaidenTilastotiedotKirjanpitajittainVastaus>('tilastotAsiakkaidenTilastotiedotKirjanpitajittain', payload)
          .then(vastaus => {
            return vastaus.tiedot
          })
      }),
      lemonShare(),
    )

    combineLatest([this._kirjanpitajaService.kirjanpitajienNimitiedotMapObservable, kirjanpitajienRaakadataObservable])
      .pipe(
        map(([kirjanpitajatMap, raakadata]) => {
          const yhteensa = {
            asiakkaita: 0,
            jatkuvakk1: 0,
            jatkuvakk2: 0,
            lisayksia: 0,
            poistuma: 0,
            keskim: 0,
            oy: 0,
            tmi: 0,
            muut: 0,
          }
          for (const rivi of raakadata) {
            rivi.asiakkaita = rivi.yhtiomuodotOy + rivi.yhtiomuodotTmi + rivi.yhtiomuodotMuut
            rivi.keskimaarainenVeloitus = rivi.jatkuvakk1 / rivi.asiakkaita
            const kirjanpitaja = kirjanpitajatMap.get(rivi.kirjanpitajaAvain)
            if (kirjanpitaja) {
              rivi.kirjanpitaja = kirjanpitaja.etunimi + ' ' + kirjanpitaja.sukunimi
            } else {
              rivi.kirjanpitaja = 'Tuntematon'
            }
            rivi.jatkuvakk2 = rivi.jatkuvakk1 + rivi.vahennykset + rivi.lisaykset
            rivi.yhtiomuotoString = rivi.yhtiomuodotTmi + '/' + rivi.yhtiomuodotOy + '/' + rivi.yhtiomuodotMuut
            yhteensa.asiakkaita += rivi.asiakkaita
            yhteensa.jatkuvakk1 += rivi.jatkuvakk1
            yhteensa.jatkuvakk2 += rivi.jatkuvakk2
            yhteensa.lisayksia += rivi.lisaykset
            yhteensa.poistuma += rivi.vahennykset
            yhteensa.oy += rivi.yhtiomuodotOy
            yhteensa.tmi += rivi.yhtiomuodotTmi
            yhteensa.muut += rivi.yhtiomuodotMuut
          }

          yhteensa.keskim += yhteensa.jatkuvakk1 / yhteensa.asiakkaita
          this.kirjanpitajittainTableYhteensa.set(yhteensa)

          return raakadata

          // const tiimi = rajaukset.tiimi ? await this._kirjanpitajanTiimiService.annaTiimi(rajaukset.tiimi) : null
          // const tiimiSet = tiimi ? this._kirjanpitajanTiimiService.annaTiiminKirjanpitajatPaivalleSet(tiimi, this._dateService.currentNumberDate()) : null
          // const paluuarvo: KirjanpitajatTablenTiedot[] = []
          // for (const kirjanpitaja of kirjanpitajat) {

          //   if (tiimiSet && !tiimiSet.has(kirjanpitaja.avain)) {
          //     continue
          //   }

          //   let voimassaolevat = 0
          //   let muutosTulevaisuudessa = 0
          //   let asiakkaita = 0
          //   let toiminimia = 0
          //   let osakeyhtioita = 0
          //   let muitaYrityksia = 0
          //   for (const asiakas of asiakkaat) {
          //     if (asiakas.k === kirjanpitaja.avain) {
          //       if (asiakas.h1) {
          //         asiakkaita++
          //         voimassaolevat += asiakas.h1
          //         if (asiakas.y === Yritysmuoto.OSAKEYHTIO) {
          //           osakeyhtioita++
          //         } else if (asiakas.y === Yritysmuoto.TOIMINIMI) {
          //           toiminimia++
          //         } else {
          //           muitaYrityksia++
          //         }
          //       }
          //       if (asiakas.h2) {
          //         if (asiakas.h1) {
          //           muutosTulevaisuudessa += (asiakas.h1 - asiakas.h2)
          //         } else {
          //           muutosTulevaisuudessa += asiakas.h2
          //         }
          //       }
          //     }
          //   }

          //   paluuarvo.push({
          //     kirjanpitaja: kirjanpitaja,
          //     asiakkaita: asiakkaita,
          //     jatkuvaVeloitus: voimassaolevat,
          //     kate: 0,
          //     kertalaskutuksetViimeinen30Pv: 0,
          //     keskimaarainenVeloitus: asiakkaita > 0 ? voimassaolevat / asiakkaita : 0,
          //     tulevatMuutokset: muutosTulevaisuudessa,
          //     yhtiomuodot: [toiminimia, osakeyhtioita, muitaYrityksia],
          //     yhtiomuotoString: toiminimia + '/' + osakeyhtioita + '/' + muitaYrityksia
          //   })

          // }

          // return paluuarvo
        }),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe(tiedot => {
        this.kirjanpitajittainTableLataa.set(false)
        this.kirjanpitajatDataSource.filter = null
        this.kirjanpitajatDataSource.data = tiedot
      })

    this._versionTarkistusPalvelu.sovelluksenVersioObservable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(versio => {
      this._versionTarkistusPalvelu.tarkistaVersio(versio)
    })

    this.naytaSuperObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(
      map(kirjanpitaja => {
        return kirjanpitaja && kirjanpitaja.rooli === KirjanpitajanRooli.SUPER
      }),
      distinctUntilChanged(),
    )

    this.naytaItJaKayttotukiObservable = this._kirjautunutKayttajaService.kirjanpitajaOnDevaajaTaiTukiTaiMuutObservable

    this.periodinLoppuInfoObservable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(periodinLoppuInfo => {
      if (periodinLoppuInfo && periodinLoppuInfo.yhtiomuotojakauma && periodinLoppuInfo.yhtiomuotojakauma.length > 0) {
        setTimeout(() => {
          if (!this.yhtiojakaumaCanvas) {
            return
          }
          const labels: string[] = []
          const data: number[] = []
          const colors: string[] = []
          let index = 0
          for (const jakauma of periodinLoppuInfo.yhtiomuotojakauma) {
            data.push(jakauma.maara)
            labels.push(jakauma.nimi + ' (' + jakauma.maara + ')')
            colors.push(this.annaYhtiomuodonVari(index))
            index++
          }

          if (this.yhtiojakaumaChart) {
            this.yhtiojakaumaChart.destroy()
          }

          this.yhtiojakaumaChart = new Chart(this.yhtiojakaumaCanvas.nativeElement.getContext('2d'), {
            type: 'pie',
            data: {
              labels: labels,
              datasets: [
                {
                  data: data,
                  backgroundColor: colors,
                },
              ],
            },
            options: {
              plugins: {
                title: {
                  display: false,
                },
                legend: {
                  display: false,
                },
              },
              responsive: false,
              maintainAspectRatio: false,
            },
          })
        }, 0)
      }
    })

    // this.asiakasInfoObservable.pipe(
    //   takeUntil(this.ngUnsubscribe)
    // ).subscribe(asiakasInfo => {

    //   if (asiakasInfo) {
    //     const labels: string[] = []
    //     const data: number[] = []
    //     const colors: string[] = []
    //     let index = 0
    //     for (const jakauma of asiakasInfo.yhtiomuotojakauma) {
    //       data.push(jakauma.maara)
    //       labels.push(jakauma.nimi)
    //       colors.push(this.annaYhtiomuodonVari(index))
    //       index++
    //     }

    //     this.yhtiojakaumaChart = new Chart(this.yhtiojakaumaCanvas.nativeElement.getContext('2d'), {
    //       type: 'pie',
    //       data: {
    //         labels: labels,
    //         datasets: [{
    //           data: data,
    //           backgroundColor: colors
    //         }]
    //       },
    //       options: {
    //         plugins: {
    //           title: {
    //             display: false
    //           },
    //           legend: {
    //             display: false
    //           }
    //         },
    //         responsive: true,
    //         maintainAspectRatio: true,
    //         aspectRatio: 1
    //       }
    //     })
    //   }

    // })

    // laskutuksenMuutosKuukausittainObservable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(muutokset => {
    //   const plussaa: number[] = []
    //   const miinusta: number[] = []
    //   const yhteensa: number[] = []
    //   const labels: string[] = []
    //   for (const muutos of muutokset) {
    //     // console.log(muutos, muutos.plussaa + muutos.miinusta)
    //     plussaa.push(muutos.plussaa)
    //     miinusta.push(muutos.miinusta)
    //     yhteensa.push(muutos.plussaa + muutos.miinusta)
    //     labels.push(muutos.vuosikk.month + '/' + muutos.vuosikk.year)
    //   }
    //
    //   if (this.kuukausittainenMuutosChart) {
    //     this.kuukausittainenMuutosChart.destroy()
    //   }
    //
    //   this.kuukausittainenMuutosChart = new Chart(this.kuukausittainenMuutosCanvasRef.nativeElement.getContext('2d'), {
    //     type: 'line',
    //     data: {
    //       labels: labels,
    //       datasets: [
    //         {
    //           label: 'Lisäys',
    //           data: plussaa,
    //           borderColor: 'rgba(184, 231, 166, 1)',
    //           backgroundColor: 'rgba(184, 231, 166, 1)',
    //           fill: false,
    //         },
    //         {
    //           label: 'Poistuma',
    //           data: miinusta,
    //           borderColor: 'rgba(242, 167, 180, 1)',
    //           backgroundColor: 'rgba(242, 167, 180, 1)',
    //           fill: false,
    //         },
    //         {
    //           label: 'Muutos',
    //           data: yhteensa,
    //           borderColor: 'rgba(153, 196, 231, 1)',
    //           backgroundColor: 'rgba(153, 196, 231, 1)',
    //           fill: false,
    //         },
    //       ],
    //     },
    //     options: {
    //       responsive: true,
    //       scales: {
    //         x: {
    //           grid: {
    //             display: false,
    //           },
    //         },
    //         y: {},
    //       },
    //     },
    //   })
    //
    //   this.kuukausittainenMuutosCanvasOnLataamatta = false
    // })

    this.naytaSuperObservable
      .pipe(
        switchMap(nayta => {
          if (nayta) {
            return combineLatest([
              // this.kirjanpitajittainJakaumaObservable,
              this._kirjanpitajaService.kirjanpitajienNimitiedotObservable,
              this._valittuAikavaliObservable,
              kirjanpitajienRaakadataObservable,
            ])
          }
          return EMPTY
        }),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe(([/* jakauma,*/ kirjanpitajat, aikavali, kirjanpitajienRaakadata]) => {
        const puretutAikavalit = this._dateService.puraAikavali(aikavali)

        const datasets: any[] = []
        let index = 0
        for (const kirjanpitaja of kirjanpitajat) {
          const luvut: number[] = []

          for (const purettu of puretutAikavalit) {
            let arvo = 0
            let tarvitseeArvoa = true
            // for (const tieto of jakauma) {
            //   if (tieto.kirjanpitajanAvain === kirjanpitaja.avain && tieto.vuosi === purettu.year && tieto.kuukausi === purettu.month) {
            //     arvo = this._currencyService.roundHalfUp(tieto.yhteensa, 2)
            //     tarvitseeArvoa = false
            //     break
            //   }
            // }

            if (tarvitseeArvoa) {
              // const kuukaudenLocalPaiva: LocalDate = { year: purettu.year, month: purettu.month, day: 2 }
              // const kuukaudenPaiva = this._dateService.localDateToDate(kuukaudenLocalPaiva)
              for (const kpdata of kirjanpitajienRaakadata) {
                if (kpdata.kirjanpitajaAvain === kirjanpitaja.avain) {
                  if (kpdata.kkJakauma) {
                    const d = kpdata.kkJakauma[purettu.year + '_' + purettu.month] ?? 0
                    arvo = this._currencyService.roundHalfUp(d, 2)
                  }
                  tarvitseeArvoa = false
                  break
                }
              }
            }

            luvut.push(arvo)
          }

          // console.log('Push', kirjanpitaja.avain, kirjanpitaja.etunimi + ' ' + kirjanpitaja.sukunimi, luvut)

          if (luvut.find(luku => luku !== 0)) {
            const color = this.annaVari(index)
            datasets.push({
              label: kirjanpitaja.etunimi + ' ' + kirjanpitaja.sukunimi,
              data: luvut,
              borderColor: color,
              backgroundColor: color,
              fill: false,
            })
            index++
          }
          // else {
          //   console.log('Suodatettiin ' + kirjanpitaja.etunimi + ' ' + kirjanpitaja.sukunimi)
          // }
        }

        const labels: string[] = []
        for (const purettu of puretutAikavalit) {
          labels.push(purettu.month + '/' + purettu.year)
        }

        // if (this.kuukausittainKirjanpitajittainChart) {
        //   this.kuukausittainKirjanpitajittainChart.destroy()
        // }

        // this.kuukausittainKirjanpitajittainChart = new Chart(this.kuukausittainKirjanpitajittainCanvasRef.nativeElement.getContext('2d'), {
        //   type: 'line',
        //   data: {
        //     labels: labels,
        //     datasets: datasets,
        //   },
        //   options: {
        //     scales: {
        //       x: {
        //         stacked: false,
        //         grid: {
        //           display: false,
        //         },
        //       },
        //       y: {
        //         stacked: false,
        //       },
        //     },
        //   },
        // })

        this.kuukausittainKirjanpitajittainCanvasOnLataamatta.set(false)
      })

    // const kuukausittainenDataObservable = combineLatest([
    //   this._valittuAikavaliObservable,
    // this.kuukausittainenJakaumaObservable,
    // laskutuksenMuutosKuukausittainObservable,
    //   this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable,
    // ]).pipe(
    //   map(([aikavali, /* jakauma, muutoksetTulevaisuudessa, */ kirjanpitaja]) => {
    // if (!kirjanpitaja) {
    //   return []
    // }

    // const rajoitettuKirjanpitajaan = kirjanpitaja && kirjanpitaja.rooli === KirjanpitajanRooli.SUPER ? null : kirjanpitaja.uid
    // const kuukaudet = this.puraJaSuodataAikavali(aikavali, rajoitettuKirjanpitajaan)

    // const returnKuukaudet: KuukausittainenLaskutusData[] = []
    // for (const kuukausi of kuukaudet) {
    //   const data: KuukausittainenLaskutusData = {
    //     kuukausi: kuukausi,
    //     hinnastosta: {
    //       laskutus: 0,
    //       lisays: 0,
    //       poistuma: 0,
    //     },
    //     laskuista: {
    //       hyvityksetJatkuva: 0,
    //       hyvityksetKerta: 0,
    //       jatkuva: 0,
    //       kerta: 0,
    //     },
    //   }

    //   const tarvitseeTulevaisuusluvun = true
    // for (const tieto of jakauma) {
    //   if (tieto.vuosi === kuukausi.year && tieto.kuukausi === kuukausi.month) {
    //     data.laskuista.kerta = this._currencyService.roundHalfUp(tieto.kertalaskutus, 2)
    //     data.laskuista.jatkuva = this._currencyService.roundHalfUp(tieto.jatkuvalaskutus, 2)
    //     data.laskuista.hyvityksetJatkuva = this._currencyService.roundHalfUp(tieto.jatkuvahyvitykset, 2)
    //     data.laskuista.hyvityksetKerta = this._currencyService.roundHalfUp(tieto.kertahyvitykset, 2)
    //     tarvitseeTulevaisuusluvun = false
    //     break
    //   }
    // }

    // if (tarvitseeTulevaisuusluvun) {
    //   for (const muutos of muutoksetTulevaisuudessa) {
    //     if (muutos.vuosikk.year === kuukausi.year && muutos.vuosikk.month === kuukausi.month) {
    //       data.laskuista.jatkuva = this._currencyService.roundHalfUp(muutos.yhteensa, 2)
    //       tarvitseeTulevaisuusluvun = false
    //       break
    //     }
    //   }
    // }

    // for (const muutos of muutoksetTulevaisuudessa) {
    //   if (muutos.vuosikk.year === kuukausi.year && muutos.vuosikk.month === kuukausi.month) {
    //     data.hinnastosta.lisays = muutos.plussaa
    //     data.hinnastosta.poistuma = muutos.miinusta
    //     data.hinnastosta.laskutus = muutos.yhteensa
    //
    //     break
    //   }
    // }

    //       returnKuukaudet.push(data)
    //     }

    //     return returnKuukaudet
    //   }),
    //   lemonShare(),
    // )

    this.naytaSpeccerObservable = this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(map(kirjanpitaja => this._kirjanpitajanTiimiService.isSpeccer(kirjanpitaja?.uid)))

    //   this.kuukausittaisenDatanRivitObservable = combineLatest([kuukausittainenDataObservable, this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable]).pipe(
    //     map(([kuukausidata, kirjanpitaja]) => {
    //       const otsikkorivi: KuukausittaisenTablenRivi = {
    //         bold: true,
    //         cols: [''],
    //       }

    //       const labelsJatkuva: string[] = []
    //       if (this._kirjanpitajanTiimiService.isSpeccer(kirjanpitaja?.uid)) {
    //         labelsJatkuva.push('Jatkuva HINNASTOSTA')
    //       } else {
    //         labelsJatkuva.push('Jatkuva laskutus')
    //       }

    //       const myyntiYhteensaRivi: KuukausittaisenTablenRivi = { bold: true, cols: ['Myynti yhteensä'] }
    //       const jatkuvaLaskutusRivi: KuukausittaisenTablenRivi = { bold: false, cols: labelsJatkuva }
    //       const kertalaskutusRivi: KuukausittaisenTablenRivi = { bold: false, cols: ['Kertalaskutus'] }
    //       const kertahyvaritRivi: KuukausittaisenTablenRivi = { bold: false, cols: ['Hyvitykset, kerta'] }
    //       const jatkuvahyvaritRivi: KuukausittaisenTablenRivi = { bold: false, cols: ['Hyvitykset, jatkuva'] }

    //       const muutosRivi: KuukausittaisenTablenRivi = { bold: true, cols: ['Muutos'] }
    //       const lisaysRivi: KuukausittaisenTablenRivi = { bold: false, cols: ['Lisäys'] }
    //       const poistumaRivi: KuukausittaisenTablenRivi = { bold: false, cols: ['Poistuma'] }

    //       const debugRivi: KuukausittaisenTablenRivi = { bold: true, cols: ['Debug'] }
    //       const jatkuvaHinnoistaRivi: KuukausittaisenTablenRivi = { bold: false, cols: ['Jatkuva LASKUISTA'] }
    //       const erotusRivi: KuukausittaisenTablenRivi = { bold: false, cols: ['Erotus'] }

    //       for (const data of kuukausidata) {
    //         otsikkorivi.cols.push(data.kuukausi.month + '/' + data.kuukausi.year)

    //         const summa = data.laskuista.kerta + data.hinnastosta.laskutus + data.laskuista.hyvityksetJatkuva + data.laskuista.hyvityksetKerta
    //         myyntiYhteensaRivi.cols.push(this._currencyService.formatoiRaha(summa, 'EUR', 'fi'))

    //         jatkuvaLaskutusRivi.cols.push(this._currencyService.formatoiRaha(data.hinnastosta.laskutus, 'EUR', 'fi'))
    //         kertalaskutusRivi.cols.push(this._currencyService.formatoiRaha(data.laskuista.kerta, 'EUR', 'fi'))
    //         kertahyvaritRivi.cols.push(this._currencyService.formatoiRaha(data.laskuista.hyvityksetKerta, 'EUR', 'fi'))
    //         jatkuvahyvaritRivi.cols.push(this._currencyService.formatoiRaha(data.laskuista.hyvityksetJatkuva, 'EUR', 'fi'))

    //         muutosRivi.cols.push(this._currencyService.formatoiRaha(data.hinnastosta.lisays + data.hinnastosta.poistuma, 'EUR', 'fi'))
    //         lisaysRivi.cols.push(this._currencyService.formatoiRaha(data.hinnastosta.lisays, 'EUR', 'fi'))
    //         poistumaRivi.cols.push(this._currencyService.formatoiRaha(data.hinnastosta.poistuma, 'EUR', 'fi'))

    //         debugRivi.cols.push('')
    //         jatkuvaHinnoistaRivi.cols.push(this._currencyService.formatoiRaha(data.laskuista.jatkuva, 'EUR', 'fi'))
    //         erotusRivi.cols.push(this._currencyService.formatoiRaha(data.hinnastosta.laskutus - data.laskuista.jatkuva, 'EUR', 'fi'))
    //       }

    //       const rivit: KuukausittaisenTablenRivi[] = []

    //       rivit.push(otsikkorivi)

    //       rivit.push(myyntiYhteensaRivi)
    //       rivit.push(jatkuvaLaskutusRivi)
    //       rivit.push(kertalaskutusRivi)
    //       rivit.push(kertahyvaritRivi)
    //       rivit.push(jatkuvahyvaritRivi)

    //       rivit.push(muutosRivi)
    //       rivit.push(lisaysRivi)
    //       rivit.push(poistumaRivi)

    //       if (this._kirjanpitajanTiimiService.isSpeccer(kirjanpitaja?.uid)) {
    //         rivit.push(debugRivi)
    //         rivit.push(jatkuvaHinnoistaRivi)
    //         rivit.push(erotusRivi)
    //       }

    //       return rivit
    //     }),
    //   )

    //   kuukausittainenDataObservable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(kuukaudenTiedot => {
    //     if (this.kuukausittainChart) {
    //       this.kuukausittainChart.destroy()
    //     }

    //     if (!kuukaudenTiedot?.length) {
    //       return
    //     }

    //     const kerta: number[] = []
    //     const jatkuva: number[] = []
    //     const kertahyvitykset: number[] = []
    //     const jatkuvahyvitykset: number[] = []
    //     const labels: string[][] = []
    //     // let summa = 0
    //     for (const data of kuukaudenTiedot) {
    //       kerta.push(data.laskuista.kerta)
    //       jatkuva.push(data.hinnastosta.laskutus)
    //       kertahyvitykset.push(data.laskuista.hyvityksetKerta)
    //       jatkuvahyvitykset.push(data.laskuista.hyvityksetJatkuva)
    //       // summa =
    //       const labelsForMonth = [data.kuukausi.month + '/' + data.kuukausi.year]
    //       labels.push(labelsForMonth)
    //     }

    //     this.kuukausittainChart = new Chart(this.kuukausittainCanvasRef.nativeElement.getContext('2d'), {
    //       type: 'bar',
    //       data: {
    //         labels: labels,
    //         datasets: [
    //           {
    //             label: 'Jatkuvalaskutus',
    //             data: jatkuva,
    //             backgroundColor: 'rgba(153, 196, 231, 1)',
    //             borderColor: 'rgba(153, 196, 231, 1)',
    //           },
    //           {
    //             label: 'Kertalaskutus',
    //             data: kerta,
    //             backgroundColor: 'rgba(184, 231, 166, 1)',
    //             borderColor: 'rgba(184, 231, 166, 1)',
    //           },
    //           {
    //             label: 'Hyvitykset, kerta',
    //             data: kertahyvitykset,
    //             backgroundColor: 'rgba(242, 167, 180, 1)',
    //             borderColor: 'rgba(242, 167, 180, 1)',
    //           },
    //           {
    //             label: 'Hyvitykset, jatkuva',
    //             data: jatkuvahyvitykset,
    //             backgroundColor: 'rgba(247, 70, 74, 1)',
    //             borderColor: 'rgba(247, 70, 74, 1)',
    //           },
    //         ],
    //       },
    //       options: {
    //         responsive: true,
    //         scales: {
    //           x: {
    //             stacked: true,
    //             grid: {
    //               display: false,
    //             },
    //           },
    //           y: {
    //             stacked: true,
    //           },
    //         },
    //       },
    //     })

    //     this.kuukausittainCanvasDataOnLataamatta = false
    //   })
  }

  toggleMyyntiyhteenvetoKategoria(kategoriaAvain: string) {
    if (this.avautunutMyyntiyhteenvetoKategoriat.has(kategoriaAvain)) {
      this.avautunutMyyntiyhteenvetoKategoriat.delete(kategoriaAvain)
    } else {
      this.avautunutMyyntiyhteenvetoKategoriat.add(kategoriaAvain)
    }
  }

  async avaaSolunTiedotMyyntiyhteenveto(td: MyyntiyhteenvetoSolu, tuoteNimi: string, isFirst: boolean) {
    if (isFirst || !td.vuosi || !td.kuukausi) {
      return
    }

    if (this.valittuMyyntiyhteenvetoSolu() === td) {
      this.valittuMyyntiyhteenvetoSolu.set(null)
      this.valittuMyyntiyhteenvetoTuoteNimi.set(null)
      this.valitunMyyntiyhteenvetoSolunLahteet.set(null)
      this.myyntiyhteenvetoLahteetEiTasmaa.set(false)
      return
    }

    this.valittuMyyntiyhteenvetoSolu.set(td)
    this.valittuMyyntiyhteenvetoTuoteNimi.set(tuoteNimi)
    this.lataaMyyntiyhteenvetoLahteet.set(true)

    try {
      const rajaukset = this._rajauksetSubject.value

      const aikavali: KuukausiAikavali = {
        start: { year: td.vuosi, month: td.kuukausi },
        end: { year: td.vuosi, month: td.kuukausi },
      }

      const pyynto: MyyntiyhteenvetoJakaumallaPyynto = {
        aikavali: aikavali,
        rajoitettuKirjanpitajaanAvain: rajaukset.kirjanpitaja,
        rajoitettuTiimiinAvain: rajaukset.tiimi,
        rajoitettuTiimiKokonaisuuteenAvain: rajaukset.tiimiKokonaisuus,
        rajoitettuTagiinAvain: this._valittuTagiSubject.value ?? null,
        tuote: td.tuote,
      }

      if (td.onPalvelumyynti) {
        pyynto.excludeTilastoKategoria = TilastoKategoria.OHJELMISTO
      }

      if (td.onHyvitys !== undefined) {
        pyynto.onHyvitys = td.onHyvitys
      }

      const vastaus = await this._firebase.functionsCall<MyyntiyhteenvetoJakaumallaPyynto, MyyntiYhteenvetoVastaus>('tilastotMyyntiYhteenveto', pyynto)

      const lahteet =
        vastaus?.kuukausidata?.[0]?.lahteet?.map(l => ({
          ...l,
          asiakasNimi: this.asiakkaatMap?.[l.av]?.nimi ?? '',
        })) ?? []
      this.valitunMyyntiyhteenvetoSolunLahteet.set(lahteet)

      // Tarkista täsmääkö lähteiden summa solun arvoon
      const lahteidenSumma = lahteet.reduce((sum, lahde) => sum + lahde.s, 0)
      const solunArvo = td.summa ?? this._currencyService.muutaMerkkijonoNumeroksiKaikkiDesimaalit(td.arvo) ?? 0
      this.myyntiyhteenvetoLahteidenSumma.set(lahteidenSumma)
      this.myyntiyhteenvetoLahteetEiTasmaa.set(Math.abs(lahteidenSumma - solunArvo) > 0.01)
    } catch (error) {
      this._errorHandler.handleError(error)
      this.valitunMyyntiyhteenvetoSolunLahteet.set([])
    } finally {
      this.lataaMyyntiyhteenvetoLahteet.set(false)
    }
  }

  async avaaSolunTiedot(solunData: KuukausittaisenSolunData) {
    if (!solunData || !solunData.kentta || !solunData.vuosi || !solunData.kuukausi) {
      return
    }

    if (this.valittuSolu() === solunData) {
      this.valittuSolu.set(null)
      this.valitunSolunLahteet.set(null)
      this.valitunSolunLahteetYhteissumma.set(0)
      this.jatkuvaLaskutusValidointi.set({ eiTasmaa: false, summa: 0, kpl: 0 })
      return
    }
    this.valittuSolu.set(solunData)
    this.valitunSolunLahteet.set(null)
    this.valitunSolunLahteetYhteissumma.set(0)
    this.jatkuvaLaskutusValidointi.set({ eiTasmaa: false, summa: 0, kpl: 0 })
    this.lataaLahteet.set(true)

    const aikavali: KuukausiAikavali = {
      start: { year: solunData.vuosi, month: solunData.kuukausi },
      end: { year: solunData.vuosi, month: solunData.kuukausi },
    }

    const payload: JatkuvaKuukaudenLaskutusJakaumallaPyynto = {
      aikavali: aikavali,
      rajoitettuKirjanpitajaanAvain: this._rajauksetSubject.value.kirjanpitaja ?? null,
      rajoitettuTiimiinAvain: this._rajauksetSubject.value.tiimi ?? null,
      rajoitettuTiimiKokonaisuuteenAvain: this._rajauksetSubject.value.tiimiKokonaisuus ?? null,
      rajoitettuTagiinAvain: this._valittuTagiSubject.value ?? null,
      palautaSolu: [solunData.kentta],
    }

    try {
      const vastaus = await this._firebase.functionsCall<JatkuvaKuukaudenLaskutusJakaumallaPyynto, JatkuvanLaskutuksenKehitysVastaus>('tilastotJatkuvanLaskutuksenKehitys', payload)
      const lahteet = vastaus.lahteet ?? []
      const yhteissumma = lahteet.reduce((sum, lahde) => sum + lahde.summa, 0)
      this.valitunSolunLahteet.set(lahteet)
      this.valitunSolunLahteetYhteissumma.set(yhteissumma)

      const solunArvo = parseFloat(solunData.arvo.replace(/\s/g, '').replace(',', '.'))
      const summaEiTasmaa = Math.abs(yhteissumma - solunArvo) > 0.01
      const kplEiTasmaa = !solunData.arvo.includes(',') && !solunData.arvo.includes('.') && lahteet.length !== solunArvo

      this.jatkuvaLaskutusValidointi.set({
        eiTasmaa: lahteet.length > 0 && (summaEiTasmaa || kplEiTasmaa),
        summa: yhteissumma,
        kpl: lahteet.length,
      })
    } catch (err) {
      this.valitunSolunLahteet.set([])
      this.valitunSolunLahteetYhteissumma.set(0)
      this.jatkuvaLaskutusValidointi.set({ eiTasmaa: false, summa: 0, kpl: 0 })
    } finally {
      this.lataaLahteet.set(false)
    }
  }

  private annaVari(index: number): string {
    return index < this.varit.length ? this.varit[index] : this.arvoVari()
  }

  private annaYhtiomuodonVari(index: number): string {
    return index < this.yhtiomuodotVarit.length ? this.yhtiomuodotVarit[index] : this.arvoVari()
  }

  private arvoVari(): string {
    return 'rgba(' + this.getRandomInt(0, 255) + ',' + this.getRandomInt(0, 255) + ',' + this.getRandomInt(0, 255) + ',1)'
  }

  private getRandomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  async lataaJatkuvanLaskutuksenKehitysCsv() {
    const [kuukausiRivi, ...datarivit] = await firstValueFrom(this.jatkuvanLaskutuksenKehitysObservable)

    const builder = new SpreadsheetBuilder()
    builder.addHeader(['', ...kuukausiRivi.cols.flatMap(solu => [`${solu.arvo} €`, `${solu.arvo} kpl`])])
    for (const rivi of datarivit) {
      builder.addRow([rivi.nimi ?? '', ...rivi.cols.flatMap(solu => [this._currencyService.formatoiDesimaaliSailytaNollat(solu.summa, 2, 'fi'), solu.kpl])])
    }

    const aikavali = this._valittuAikavaliSubject.value
    const tiedostonNimi = `Jatkuvan laskutuksen kehitys ${aikavali.start.month}.${aikavali.start.year} - ${aikavali.end.month}.${aikavali.end.year}.csv`
    this._fileSaverService.saveStringAs(builder.toString(), tiedostonNimi, 'csv')
  }

  private puraJaSuodataAikavali(aikavali: KuukausiAikavali, rajoitettuKirjanpitajaanAvain: string): LocalMonth[] {
    const purettu = this._dateService.puraAikavali(aikavali)
    const takarajaKk = rajoitettuKirjanpitajaanAvain ? 11 : 10
    return purettu.filter(a => {
      return a.year > 2018 || (a.year === 2018 && a.month >= takarajaKk)
    })
  }

  // async lataaLaskutusKirjanpitajittain2020Viiva2024() {
  //     const pyynto: AnnaKuukaudenLaskutusKirjanpitajittainJakaumallaPyynto = {
  //       aikavali: { start: { year: 2020, month: 1 }, end: { year: 2024, month: 12 } },
  //       palautaLahteet: false,
  //       rajoitettuKirjanpitajaanAvain: null,
  //       rajoitettuTiimiinAvain: null,
  //     }

  //     const kirjanpitajatMapPromise = firstValueFrom(this._kirjanpitajaService.kirjanpitajienNimitiedotMapObservable)
  //     const jakaumatPromise = this._firebase
  //       .functionsCall<AnnaKuukaudenLaskutusKirjanpitajittainJakaumallaPyynto, AnnaKuukaudenLaskutusKirjanpitajittainJakaumallaVastaus>('tilastotLaskutusKirjanpitajittainKuukausittain', pyynto)
  //       .then(vastaus => {
  //         return vastaus?.jakaumadata ?? []
  //       })

  //     const [jakaumat, kirjanpitajatMap] = await Promise.all([jakaumatPromise, kirjanpitajatMapPromise])

  //     const kirjanpitajittainMap = new Map<string, KuukaudenLaskutusKirjanpitajittainJakaumallaTiedot[]>()
  //     for (const jakauma of jakaumat) {
  //       if (!kirjanpitajittainMap.has(jakauma.kirjanpitajanAvain)) {
  //         kirjanpitajittainMap.set(jakauma.kirjanpitajanAvain, [])
  //       }
  //       kirjanpitajittainMap.get(jakauma.kirjanpitajanAvain).push(jakauma)
  //     }

  //     const kirjanpitajittainKaikki = Array.from(kirjanpitajittainMap.values()).sort((a, b) => {
  //       const aKpN = kirjanpitajatMap.get(a[0].kirjanpitajanAvain)
  //       const bKpN = kirjanpitajatMap.get(b[0].kirjanpitajanAvain)
  //       const aKp = aKpN ? aKpN.sukunimi + ' ' + aKpN.etunimi : 'Tuntematon'
  //       const bKp = bKpN ? bKpN.sukunimi + ' ' + bKpN.etunimi : 'Tuntematon'
  //       return aKp.localeCompare(bKp)
  //     })

  //     const kirjanpitajittain: KuukaudenLaskutusKirjanpitajittainJakaumallaTiedot[][] = []
  //     for (const k of kirjanpitajittainKaikki) {
  //       const kpTiimi = await this._kirjanpitajanTiimiService.annaKirjanpitajanEnsimmainenTiimi(k[0].kirjanpitajanAvain, this._dateService.currentNumberDate())
  //       if (kpTiimi?.avain === KirjanpitajaTiimiAvaimet.IT) {
  //         continue
  //       }
  //       kirjanpitajittain.push(k)
  //     }

  //     const kuukaudet = this._dateService.puraAikavali(pyynto.aikavali)

  //     const builder = new SpreadsheetBuilder()
  //     const headerRow: string[] = ['Kirjanpitäjä', 'Tiimi']
  //     for (const kk of kuukaudet) {
  //       headerRow.push(kk.month + '/' + kk.year + ' j')
  //       headerRow.push(kk.month + '/' + kk.year + ' jh')
  //       headerRow.push(kk.month + '/' + kk.year + ' k')
  //       headerRow.push(kk.month + '/' + kk.year + ' kh')
  //     }
  //     builder.addHeader(headerRow)

  //     for (const kirjanpitajanRivit of kirjanpitajittain) {
  //       const aKpN = kirjanpitajatMap.get(kirjanpitajanRivit[0].kirjanpitajanAvain)
  //       const aKp = aKpN ? aKpN.sukunimi + ' ' + aKpN.etunimi : 'Tuntematon'

  //       const kpTiimi = await this._kirjanpitajanTiimiService.annaKirjanpitajanEnsimmainenTiimi(kirjanpitajanRivit[0].kirjanpitajanAvain, this._dateService.currentNumberDate())
  //       const dataRow: SpreadsheetCellValue[] = [aKp, kpTiimi ? kpTiimi.nimi : 'Ei tiimiä']

  //       kirjanpitajanRivit.sort((a, b) => {
  //         if (a.vuosi !== b.vuosi) {
  //           return a.vuosi - b.vuosi
  //         }
  //         return a.kuukausi - b.kuukausi
  //       })
  //       for (const kk of kuukaudet) {
  //         const rivi = kirjanpitajanRivit.find(r => r.vuosi === kk.year && r.kuukausi === kk.month)
  //         if (rivi) {
  //           dataRow.push(rivi.jatkuvalaskutus, rivi.jatkuvahyvitykset, rivi.kertalaskutus, rivi.kertahyvitykset)
  //         } else {
  //           dataRow.push('', '', '', '')
  //         }
  //       }
  //       builder.addRow(dataRow)
  //     }

  //     const fileName = 'Laskutus kirjanpitäjittäin ' + pyynto.aikavali.start.month + '.' + pyynto.aikavali.start.year + ' - ' + pyynto.aikavali.end.month + '.' + pyynto.aikavali.end.year + '.csv'
  //     this._fileSaverService.saveStringAs(builder.toString(), fileName, 'csv')
  //   }

  private _endBeforeStartValidator: ValidatorFn = (): ValidationErrors => {
    // Reaktiivisessa lomakkeessa kenttä validoitiin vain sen oman arvon muuttuessa, joten toisen kentän muutos ei saa laukaista validointia
    const start = untracked(() => this.lomake?.vuosikkalku().value())
    const end = untracked(() => this.lomake?.vuosikkloppu().value())

    if (!start && !end) {
      return null
    }

    if (start > end) {
      return { endBeforeStart: true }
    }
    return null
  }
}
